<template>
  <button id="forceUpdate" style="opacity:0; z-index:-999;     display: block;" v-on:click="getDashChartsClient({PK: '#SMARTDASH', SK:'#SML#55994203-121c-4092-b8d6-36d90c65251a',GSP1PK1 :$router.currentRoute.value.query.data })">
  </button>
  <div class="paper-dash" v-if="$router.currentRoute.value.query.name == 'dash'">
    <div class="smart-wrap" v-if="dataCharts != undefined">
      <div class="input-wrap col-md-12">
        <select name="" id="" v-model="year" v-on:change="getDashDataCharts({PK: organizationID})">
          <option value="" hidden>Select Options</option>
          <option value="2022">2022</option>
          <option value="2021">2021</option>
          <option value="2020">2020</option>
          <option value="2019">2019</option>
          <option value="2018">2018</option>
        </select>
      </div>
      <div class="element-wrap col-md-6" v-for="(chart, index) in dataCharts" :key="index"> 
        <ui-charts-v-2 :type="chart.chartType" :color="organizationData.colorSeriesA" :data="chart" :index='index' />
      </div>
    </div>
  </div>
  <div  class="paper-dash" v-else-if="$router.currentRoute.value.query.name == 'clietDash'">
    <div v-if="dataCharts != undefined" class="smart-wrap">
      <div class="element-wrap col-12 " v-if="contact != null">
        <div class="row">
          <div class="col-md-6">
            <h4 style="float:left;">{{contact['contact.firstName']+' '+ contact['contact.lastName'] }}  &nbsp; &nbsp;</h4>
            <div class="options" style="float:left;" >
              <div style="float:left;" >
                <a href="#" v-on:click="getDashChartsClient({PK: '#SMARTDASH', SK:'#SML#55994203-121c-4092-b8d6-36d90c65251a',GSP1PK1 :$router.currentRoute.value.query.data })" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" title="Action">
                  <ui-accion-button action="refresh"/>
                </a>
              </div>
              <div style="float:left;" >
                <a style="cursor: pointer" data-toggle="modal" data-target="#modal-update" v-on:click="setgRecord([contact, 'edit']);" title="Edit">
                  <ui-accion-button action="edit"/>
                </a>
              </div>
              <div style="float:left;"  title="Attachments" >
                <a v-if="contact.oldSystemClientId != undefined && contact.oldSystemClientId != ''" :href="'https://genreq.sharepoint.com/TeamSite/BizPlanEasyBPlans/Shared%20Documents/Forms/AllItems.aspx?RootFolder=%2FTeamSite%2FBizPlanEasyBPlans%2FShared%20Documents%2FC'+contact.oldSystemClientId" target="_blank">
                  <div class="col send"> 
                    <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" width="1em" height="1em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24"><path fill="currentColor" d="M20 5h-9.586L8.707 3.293A.997.997 0 0 0 8 3H4c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V7c0-1.103-.897-2-2-2z"/></svg>
                  </div>
                </a>
                <a v-else :href="'https://genreq.sharepoint.com/TeamSite/BizPlanEasyBPlans/SitePages/Home.aspx?RootFolder=%2FTeamSite%2FBizPlanEasyBPlans%2FShared%20Documents%2Fsmd%5F'+contact.friendlyId" target="_blank">
                  <div class="col send"> 
                    <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" width="1em" height="1em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24"><path fill="currentColor" d="M20 5h-9.586L8.707 3.293A.997.997 0 0 0 8 3H4c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V7c0-1.103-.897-2-2-2z"/></svg>
                  </div>
                </a>
              </div>
              <div style="float:left;" >
                <a style="cursor: pointer" data-toggle="modal" data-target="#modal-docs"  v-on:click="getItem(contact, 'out'); docsGenerate('init', contact);" title="Generate Docs">
                  <ui-accion-button action="docs"/>
                </a>
              </div>
              <div style="float:left;" >
                <a style="cursor: pointer"  v-on:click="setgRecord([contact, 'sms']);" >
                  <ui-accion-button action="sms"/>
                </a>
              </div>
              <div style="float:left;" >
                <a style="cursor: pointer" v-on:click="setgRecord([contact, 'email'])" title="Send Email">
                  <ui-accion-button action="email"/>
                </a>
              </div>
              <div style="float:left;" class="dropdown show">
                <a v-if="JSON.parse(entities['CON']['SML.descendantEntitiesWithForm']).length != 0" href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" title="Action">
                  <ui-accion-button action="action"/>
                </a>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                  <a class="dropdown-item" style="cursor: pointer; overflow:hidden;" v-for="(action, aindex) in JSON.parse(entities['CON']['SML.descendantEntitiesWithForm'])" :key="aindex" v-on:click="setgRecord([contact, 'action', aindex]);"  data-toggle="modal" data-target="#modal-update">
                    <ui-accion-button v-if="action['metaEntity.descendantEntities'].id.length == 3 && entities[action['metaEntity.descendantEntities'].id].icon">
                      <img :src="JSON.parse(entities[action['metaEntity.descendantEntities'].id].icon)[0].url" alt="">
                    </ui-accion-button>
                    <span style="padding: 6px 0; display: block;">
                      &nbsp;{{action['modules.formSK'].value}}
                    </span>
                  </a>
                </div>
              </div>
              
            </div>
            <p style="clear:both;" class="infoItem" data-toggle="collapse" href="#infoContact" role="button" aria-expanded="false" aria-controls="infoContact">{{contact.PK}}: {{ contact.entityName+ '-'+ contact.friendlyId}}</p>
            <div class="collapse" id="infoContact">
              <div class="card card-body">
                <p style="color: #949494; margin:0; font-size: 12px; padding: 0;" >  <strong>PK </strong> {{contact.PK}}</p>
                <p style="color: #949494; margin:0; font-size: 12px; padding: 0;" >  <strong>SK </strong> {{contact.SK}}</p>
                <p style="color: #949494; margin:0; font-size: 12px; padding: 0;" v-show="index != 'attributes' && index != 'strAtt' &&  att != undefined && att != '' "  v-for="(att, index) in formatData('JSON',modules['CON'].headers)"  :key="index">  <strong>{{att.label+': '}} </strong> {{contact[att.attributeName]}}</p>
              </div>
            </div>
            <div class="list-group col-8" style="margin: 20px 0;">
              <a href="#" class="list-group-item list-group-item-action" v-if="contact.attributes.paymentMethods && contact.attributes.paymentMethods.attributeValue"  v-for="(item, index) in JSON.parse(contact.attributes.paymentMethods.attributeValue)" :key="index">
                <p data-toggle="collapse" :href="'#collapse-'+index" role="button" aria-expanded="false" aria-controls="collapseExample" class="absoluteCenterFlex" style="justify-content: space-between;">
                  <div  class="absoluteCenterFlex">
                    &nbsp;  
                    <svg v-if="item.type=='Visa'" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32"><path fill="currentColor" d="M23.26 11.495a6.734 6.734 0 0 0-2.323-.401c-2.557 0-4.364 1.292-4.375 3.141c-.021 1.359 1.281 2.125 2.265 2.583c1.011.469 1.349.761 1.344 1.177c-.005.641-.808.927-1.547.927c-1.027 0-1.584-.14-2.443-.5l-.319-.151l-.364 2.136c.625.255 1.745.479 2.901.5c2.724 0 4.5-1.281 4.52-3.256c.021-1.083-.676-1.905-2.161-2.583c-.896-.437-1.457-.735-1.457-1.183c0-.396.479-.812 1.479-.812a4.763 4.763 0 0 1 1.937.359l.245.109l.359-2.057zm6.647-.224h-2c-.625 0-1.089.167-1.365.787l-3.844 8.713h2.719l.548-1.427l3.317.005c.083.333.317 1.421.317 1.421H32zm-17.027-.078h2.589l-1.62 9.504H11.26l1.62-9.509zm-6.583 5.234l.265 1.323l2.536-6.479h2.745l-4.084 9.484H5.026l-2.24-8.031a.507.507 0 0 0-.245-.317A10.935 10.935 0 0 0 0 11.464l.031-.199h4.177c.563.021 1.021.199 1.177.803l.912 4.364zm20.406.974l1.037-2.661c-.016.025.213-.547.343-.907l.177.817l.6 2.745h-2.157z"/></svg>
                    <svg v-else-if="item.type=='Mastercard'" width="32" height="32" viewBox="0 0 2000 1556" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_2942_2)">
                          <path
                            d="M1960.59 1534.9V1538.9H1964.32C1965.02 1538.91 1965.71 1538.74 1966.32 1538.39C1966.56 1538.22 1966.76 1537.99 1966.89 1537.72C1967.02 1537.45 1967.08 1537.16 1967.07 1536.86C1967.08 1536.57 1967.02 1536.28 1966.89 1536.02C1966.76 1535.76 1966.56 1535.53 1966.32 1535.37C1965.72 1535.01 1965.02 1534.83 1964.32 1534.86H1960.59V1534.9ZM1964.36 1532.07C1965.96 1531.97 1967.54 1532.43 1968.84 1533.37C1969.36 1533.8 1969.77 1534.34 1970.05 1534.95C1970.32 1535.57 1970.44 1536.24 1970.41 1536.91C1970.43 1537.49 1970.33 1538.06 1970.12 1538.6C1969.9 1539.14 1969.57 1539.62 1969.15 1540.02C1968.15 1540.89 1966.89 1541.41 1965.57 1541.51L1970.57 1547.21H1966.72L1962.12 1541.55H1960.63V1547.21H1957.41V1532.08H1964.41L1964.36 1532.07ZM1963.36 1552.43C1965.05 1552.45 1966.72 1552.11 1968.27 1551.43C1969.76 1550.79 1971.12 1549.87 1972.27 1548.72C1973.42 1547.57 1974.34 1546.22 1974.98 1544.72C1976.29 1541.55 1976.29 1537.99 1974.98 1534.82C1974.33 1533.33 1973.41 1531.97 1972.27 1530.82C1971.12 1529.67 1969.76 1528.75 1968.27 1528.11C1966.71 1527.47 1965.04 1527.15 1963.36 1527.17C1961.65 1527.15 1959.95 1527.47 1958.36 1528.11C1956.83 1528.74 1955.45 1529.66 1954.27 1530.82C1952.5 1532.63 1951.3 1534.93 1950.83 1537.42C1950.36 1539.91 1950.62 1542.48 1951.6 1544.82C1952.21 1546.32 1953.12 1547.68 1954.27 1548.82C1955.45 1549.98 1956.83 1550.9 1958.36 1551.53C1959.94 1552.2 1961.64 1552.55 1963.36 1552.53M1963.36 1523.53C1967.76 1523.53 1971.98 1525.25 1975.11 1528.33C1976.62 1529.81 1977.82 1531.57 1978.65 1533.52C1979.5 1535.52 1979.95 1537.67 1979.95 1539.84C1979.95 1542.02 1979.5 1544.17 1978.65 1546.17C1977.81 1548.11 1976.6 1549.87 1975.11 1551.36C1973.58 1552.83 1971.79 1554.02 1969.84 1554.86C1967.79 1555.73 1965.59 1556.17 1963.36 1556.16C1961.11 1556.18 1958.88 1555.73 1956.8 1554.86C1954.83 1554.04 1953.03 1552.85 1951.49 1551.36C1950 1549.81 1948.81 1547.99 1948 1546C1947.15 1544 1946.7 1541.85 1946.7 1539.68C1946.7 1537.5 1947.15 1535.35 1948 1533.35C1948.83 1531.4 1950.03 1529.64 1951.54 1528.16C1953.05 1526.65 1954.86 1525.45 1956.85 1524.66C1958.93 1523.79 1961.16 1523.34 1963.41 1523.36M432.16 1465.1C432.16 1436.25 451.06 1412.55 481.95 1412.55C511.47 1412.55 531.39 1435.23 531.39 1465.1C531.39 1494.97 511.47 1517.65 481.95 1517.65C451.06 1517.65 432.16 1493.95 432.16 1465.1ZM565.04 1465.1V1383H529.35V1403C518.03 1388.22 500.86 1378.95 477.51 1378.95C431.51 1378.95 395.41 1415.03 395.41 1465.14C395.41 1515.25 431.49 1551.33 477.51 1551.33C500.85 1551.33 518.03 1542.05 529.35 1527.28V1547.21H565V1465.1H565.04ZM1770.96 1465.1C1770.96 1436.25 1789.86 1412.55 1820.76 1412.55C1850.31 1412.55 1870.2 1435.23 1870.2 1465.1C1870.2 1494.97 1850.31 1517.65 1820.76 1517.65C1789.87 1517.65 1770.96 1493.95 1770.96 1465.1ZM1903.88 1465.1V1317.1H1868.16V1403C1856.84 1388.22 1839.67 1378.95 1816.32 1378.95C1770.32 1378.95 1734.22 1415.03 1734.22 1465.14C1734.22 1515.25 1770.3 1551.33 1816.32 1551.33C1839.67 1551.33 1856.84 1542.05 1868.16 1527.28V1547.21H1903.88V1465.1ZM1008 1410.86C1031 1410.86 1045.77 1425.28 1049.54 1450.67H964.38C968.19 1426.97 982.58 1410.86 1008.01 1410.86M1008.72 1378.86C960.62 1378.86 926.97 1413.86 926.97 1465.05C926.97 1517.24 961.97 1551.24 1011.11 1551.24C1035.83 1551.24 1058.47 1545.07 1078.39 1528.24L1060.9 1501.79C1047.14 1512.79 1029.62 1518.96 1013.15 1518.96C990.15 1518.96 969.21 1508.31 964.06 1478.76H1085.93C1086.28 1474.32 1086.64 1469.84 1086.64 1465.04C1086.28 1413.87 1054.64 1378.85 1008.7 1378.85M1439.6 1465.04C1439.6 1436.19 1458.5 1412.49 1489.39 1412.49C1518.91 1412.49 1538.83 1435.17 1538.83 1465.04C1538.83 1494.91 1518.91 1517.59 1489.39 1517.59C1458.5 1517.59 1439.59 1493.89 1439.59 1465.04M1572.47 1465.04V1383H1536.8V1403C1525.44 1388.22 1508.31 1378.95 1484.96 1378.95C1438.96 1378.95 1402.86 1415.03 1402.86 1465.14C1402.86 1515.25 1438.94 1551.33 1484.96 1551.33C1508.31 1551.33 1525.44 1542.05 1536.8 1527.28V1547.21H1572.48V1465.1L1572.47 1465.04ZM1238.05 1465.04C1238.05 1514.83 1272.71 1551.23 1325.61 1551.23C1350.33 1551.23 1366.8 1545.73 1384.61 1531.66L1367.47 1502.81C1354.07 1512.44 1340 1517.59 1324.47 1517.59C1295.98 1517.24 1275.03 1496.64 1275.03 1465.04C1275.03 1433.44 1295.98 1412.85 1324.47 1412.49C1339.96 1412.49 1354.03 1417.64 1367.47 1427.27L1384.61 1398.42C1366.77 1384.35 1350.3 1378.85 1325.61 1378.85C1272.71 1378.85 1238.05 1415.24 1238.05 1465.04ZM1698.15 1378.85C1677.56 1378.85 1664.15 1388.48 1654.88 1402.9V1383H1619.51V1547.12H1655.24V1455.12C1655.24 1427.96 1666.91 1412.87 1690.24 1412.87C1697.88 1412.76 1705.47 1414.16 1712.56 1417L1723.56 1383.36C1715.66 1380.25 1705.36 1378.88 1698.13 1378.88M741.49 1396.05C724.32 1384.73 700.66 1378.88 674.56 1378.88C632.98 1378.88 606.21 1398.81 606.21 1431.42C606.21 1458.18 626.14 1474.69 662.84 1479.84L679.7 1482.24C699.27 1484.99 708.51 1490.14 708.51 1499.41C708.51 1512.1 695.51 1519.34 671.1 1519.34C646.38 1519.34 628.54 1511.44 616.51 1502.17L599.74 1530C619.31 1544.42 644.03 1551.3 670.8 1551.3C718.2 1551.3 745.67 1528.98 745.67 1497.73C745.67 1468.88 724.05 1453.79 688.33 1448.64L671.51 1446.2C656.06 1444.2 643.68 1441.09 643.68 1430.09C643.68 1418.09 655.35 1410.87 674.93 1410.87C695.88 1410.87 716.16 1418.77 726.1 1424.94L741.55 1396.09L741.49 1396.05ZM1202 1378.91C1181.41 1378.91 1168 1388.54 1158.77 1402.96V1383H1123.4V1547.12H1159.09V1455.12C1159.09 1427.96 1170.76 1412.87 1194.09 1412.87C1201.73 1412.76 1209.32 1414.16 1216.41 1417L1227.41 1383.36C1219.51 1380.25 1209.21 1378.88 1201.98 1378.88M897.44 1383H839.08V1333.21H803V1383H769.71V1415.62H803V1490.49C803 1528.57 817.78 1551.25 860 1551.25C875.49 1551.25 893.33 1546.45 904.65 1538.56L894.34 1508C883.69 1514.17 872.02 1517.28 862.74 1517.28C844.9 1517.28 839.08 1506.28 839.08 1489.81V1415.65H897.44V1383ZM363.85 1547.16V1444.16C363.85 1405.37 339.13 1379.27 299.28 1378.92C278.33 1378.57 256.72 1385.09 241.59 1408.12C230.27 1389.92 212.43 1378.92 187.35 1378.92C169.82 1378.92 152.69 1384.07 139.28 1403.29V1383H103.56V1547.12H139.56V1456.12C139.56 1427.63 155.36 1412.49 179.76 1412.49C203.46 1412.49 215.45 1427.94 215.45 1455.76V1547.1H251.53V1456.1C251.53 1427.61 268 1412.47 291.69 1412.47C316.06 1412.47 327.69 1427.92 327.69 1455.74V1547.08L363.85 1547.16Z"
                            fill="#231F20" />
                          <path
                            d="M1980.94 1001.22V977.22H1974.69L1967.46 993.69L1960.27 977.22H1954V1001.22H1958.44V983.14L1965.2 998.74H1969.8L1976.56 983.1V1001.22H1980.96H1980.94ZM1941.29 1001.22V981.33H1949.29V977.28H1928.85V981.33H1936.85V1001.22H1941.25H1941.29Z"
                            fill="#2E2E2E" />
                          <path d="M1270.57 1104.15H729.71V132.15H1270.58L1270.57 1104.15Z" fill="#454545" />
                          <path
                            d="M764 618.17C764 421 856.32 245.36 1000.08 132.17C891.261 46.3646 756.669 -0.204819 618.09 -6.00748e-05C276.72 -6.00748e-05 0 276.76 0 618.17C0 959.58 276.72 1236.34 618.09 1236.34C756.672 1236.55 891.268 1189.98 1000.09 1104.17C856.34 991 764 815.35 764 618.17Z"
                            fill="#231F20" />
                          <path
                            d="M2000.25 618.17C2000.25 959.58 1723.53 1236.34 1382.16 1236.34C1243.56 1236.54 1108.95 1189.97 1000.11 1104.17C1143.91 990.98 1236.23 815.35 1236.23 618.17C1236.23 420.99 1143.91 245.36 1000.11 132.17C1108.95 46.3673 1243.56 -0.201108 1382.15 3.85437e-05C1723.52 3.85437e-05 2000.24 276.76 2000.24 618.17"
                            fill="#626262" />
                      </g>
                      <defs>
                          <clipPath id="clip0_2942_2">
                            <rect width="2000" height="1556" fill="white" />
                          </clipPath>
                      </defs>
                    </svg>
                    <span v-else>{{  item.type }}</span>
                    &nbsp;&nbsp;
                    **** **** **** {{ item.last4Digits }}
                  </div>
                  <!--div  class="absoluteCenterFlex"> 
                    <svg style="cursor: pointer;" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="m9 20.42l-6.21-6.21l2.83-2.83L9 14.77l9.88-9.89l2.83 2.83L9 20.42Z"/></svg>
                    <svg style="cursor: pointer;" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="red" d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"/></svg>
                  </!--div-->

                </p>
                <div class="collapse" :id="'collapse-'+index">
                  data
                </div>
              </a>
              <a href="#" class="list-group-item list-group-item-action" style="" >
                
                <p style="font-weight: 700;" data-toggle="collapse" :href="'#collapse-addCard'" role="button" aria-expanded="false" aria-controls="collapseExample" v-on:click="setPaymentMethods()">
                  Payment Method
                </p>
                <div class="collapse" :id="'collapse-addCard'">
                  <p style="margin: 10px 0;">Enter credit card information for future payments</p>
                  <div class="demo-frame ">
                    <form action="/" method="post"  id="cardForm" autocomplete="off">
                      <label class="hosted-fields--label" for="card-number">Card Number</label>
                      <div id="card-number" class="hosted-field"></div>
            
                      <label class="hosted-fields--label" for="expiration-date">Expiration Date</label>
                      <div id="expiration-date" class="hosted-field"></div>
            
                      <label class="hosted-fields--label" for="cvv">CVV</label>
                      <div id="cvv" class="hosted-field"></div>
            
                      <label class="hosted-fields--label" for="postal-code">Postal Code</label>
                      <div id="postal-code" class="hosted-field"></div>
            
                      <div class="button-container">
                      <br>
                      <div class="input-wrap col-12" style="text-align: left;">
                        <input type="checkbox" class="box" />
                        <span class="text" style="font-size:12px;display: block;float: right;width: calc(100% - 20px); padding: 0 0 0 10px;" > Save this CC for future transactions </span>
                        <br>
                        <input type="checkbox" class="box" v-model="tandc"/>
                        <span class="text" style="font-size:12px;display: block;float: right;width: calc(100% - 20px); padding: 0 0 0 10px;" >I agree to the <a href="publicOrganizationData.termsAndConditions" target="_blank">terms and conditions</a></span>
                      </div>
                      <br>
                      <input v-if="tandc == true" type="submit" class="btn-g show green center" value="Save" style="cursor:pointer;" id="submit" v-on:click="action()" />
                      <input v-else  class="btn-g show gray center" style="cursor:pointer;" value="Save" disabled />
                      </div>
                    </form>
                  </div>
                </div>
              </a>
            </div>
          </div>
          <div class="col-md-6 absoluteCenterFlex" style="align-items: stretch;flex-direction: column;" >
            <div class="row">
              <div class="col-md-6">
                <h6 style="clear:both;" v-for="(email, index) in contact.emails" :key="index" > {{email['contact.email']}}</h6>
              </div>
              <div class="col-md-6">
                <h6 style="clear:both;" v-for="(phone, index) in contact.phones" :key="index" > {{ formatData( 'phone',phone.phoneNumber)}}</h6>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="element-wrap col-md-6" v-for="(item, index) in dataCharts" :key="index"> 
        <p v-if="item.type == 'item'"> {{item.data}}</p>
        <p v-if="item.type == 'table'"> {{item.data}}</p>
        <div v-show="item.type == 'chart'"    >
          <ui-charts-v-2 :type="item.data.chartType" :color="organizationData.colorSeriesA[2]" :data="item.data" :index='index'/> 
        </div>
      </div>
      <div class="element-wrap col-12" style="margin:40px 0 0 0;" v-if="tableRecords!= null ">
        <div >
          <ul class="nav nav-tabs" id="myTab" role="tablist">
            <!-- getDashChartsClient({PK: '#SMARTDASH', SK:'#SML#55994203-121c-4092-b8d6-36d90c65251a',GSP1PK1 :$router.currentRoute.value.query.data }) -->
            <li class="nav-item" v-for="(entity, index) in tableRecords.src" :key="index" v-on:click=" tableRecords.ram = Array.from(tableRecords.src[index]); filterEntity = index ; focusEntity = index; pagination.index =0; pagination.position=0">
              <a :class="{'nav-link':true,  'active': index == focusEntity}" :id="index+'-tab'"  data-toggle="tab" :href="'#'+index" role="tab" :aria-controls="index" aria-selected="true">
                {{index}}
              </a>
            </li>
          </ul>
          <div class="tab-content" id="myTabContent">
            <div class="pagination" v-if="focusEntity == 'ALL' || focusEntity == 'COMMUNICATION'">
  
              <a 
                href="#" 
                :class="{'active':index == pagination.index }" 
                v-on:click="
                  tableRecords.ram = Array.from(tableRecords.src[focusEntity]);
                  pagination.index = index;
                  pagination.position = (pagination.index*pagination.display);
                "
                v-for="(item, index) in Math.floor(tableRecords.src[focusEntity].length / pagination.display)+1 " :key="index"
              > 
                {{ index+1 }} 
              </a>
            </div>
            <div class="smart-wrap">  
              <div class="input-wrap col-md-2">
                <label style="width:100%;" for="">Search..</label>
                <input   type="text" id="searchTableInput" v-on:keyup.enter="searchList" title="Type in a name" v-model="v_search" autocomplete="off"/>
                <i class="bx bx-x clearSearch"  v-on:click="clearSearch()"></i>
              </div>
              <div class="input-wrap col-md-1">
                <label for="">View </label>
                <select v-model="activeStatus" v-on:change="getDashChartsClient({PK: '#SMARTDASH', SK:'#SML#55994203-121c-4092-b8d6-36d90c65251a',GSP1PK1 :$router.currentRoute.value.query.data })">
                  <option value="1">Active</option>
                  <option value="2">Archived</option>
                  <option value="0">Deleted</option>
                  <option value="3">All but Deleted</option>
                  <option value="4">All</option>
                </select> 
              </div>
              <div class="input-wrap col-md-1" v-if="false">
                <label for="">Entity </label>
                <select name="" id="" v-model="filterEntity" v-on:change="getDashChartsClient({PK: '#SMARTDASH', SK:'#SML#55994203-121c-4092-b8d6-36d90c65251a',GSP1PK1 :$router.currentRoute.value.query.data })">
                  <option value="all">All</option>
                  <option v-for="(entity, index) in tableEntities" :key="index" :value="entity[0]">{{entity[1]}}</option>
                </select>
              </div>
            </div>
            {{tableRecords.ram.length}}
            <div v-for="(entity, eindex) in tableRecords.src" :key="eindex" :class="{'tab-pane fade show':true, 'active': eindex == focusEntity }" style="padding:10px 0;" :id="eindex" role="tabpanel" :aria-labelledby="eindex+'-tab'">
              <ui-table v-if="focusEntity == 'ALL'"> 
                <template #head>
                  <th class="index" :style="'background:'+organizationData.colorSeriesA[0]+';'"></th>
                  <th>#</th>
                  <th>Created At</th>
                  <th>Attributes</th>
                  <th>Status</th>
                  <th></th>
                  <th>Permissions</th>
                  <th>Actions</th>
                </template>
                <template #body  >
                  
                  <tr v-for="(item, index) in tableRecords.ram.splice( pagination.position, pagination.display)" :key="index" style="cursor:pointer;" class="tr-hover" > 
                    <td :style="'background:'+organizationData.colorSeriesA[0]+';'" data-toggle="modal" data-target="#modal-update" v-on:click="setgRecord([item, 'update']);f_emailTemplates('list',item.PK , item.SK, item )"  class="index contact"> 
                      <div class="options" v-if="entities[item.shortEntity].icon">
                        <img style="width:20px; height: 20px;"  :src="JSON.parse(entities[item.shortEntity].icon)[0].url" alt="">
                      </div>
                    </td>
                    <td data-toggle="modal" data-target="#modal-update" v-on:click="setgRecord([item, 'update']);f_emailTemplates('list',item.PK , item.SK, item )" style="font-size: 12px;">{{item.friendlyId}}</td>
                    <td data-toggle="modal" data-target="#modal-update" v-on:click="setgRecord([item, 'update']);f_emailTemplates('list',item.PK , item.SK, item )" style="font-size: 12px;"> {{formatData('date',item.createdAt)[0]}} <br> {{formatData('date',item.createdAt)[1]}} </td>
                    <td data-toggle="modal" data-target="#modal-update" v-on:click="setgRecord([item, 'update']);f_emailTemplates('list',item.PK , item.SK, item )" >
                      <strong>{{item.entityName}}</strong> <br>
                      <span v-show="typeof checkAttribute(att) == 'object'" v-for="(att, zindex) in formatData('JSON',modules[item.shortEntity].dashAttributes)" :key="zindex" style="font-size: 12px;">
                        <strong v-if="att.label != ''" v-show="item[att.attributeName] != ''">{{att.label+': '}}</strong>
                        <span v-show="item[att.attributeName] != ''" v-if="typeof item[att.attributeName] == 'object'"  >
                          <span v-for="(dataItem, dataindex) in item[att.attributeName]" :key="dataindex" >
                            <span v-if="dataindex != 'PK' && dataindex != 'SK'">
                              <span v-if="typeof dataItem == 'object' " >
                                <span  v-for="(key, xindex) in dataItem" :key="xindex">
                                {{key}}
                                </span>
                              </span>
                              <span v-if="typeof dataItem == 'string'"> 
                                {{ dataItem }} 
                              </span>
                            </span>
                          </span>
                        </span>
                        <span v-show="item[att.attributeName] != ''" v-else > 
                          <span v-if="att.inputType == '' || att.inputType == 'preloadList'"> 
                            <span v-for="(xitem, xindex) in item[att.attributeName]" :key="xindex" >
                              <span v-if="xindex != 'PK' && zindex != 'SK'"> 
                                {{xitem}}
                              </span>
                            </span>
                          </span>
                          <span v-else-if="att.inputType == 'range' && item[att.attributeName]">
                            <div class="progress" :style="'background:'+organizationData.colorSeriesA[1]+'!important;'">
                              <div class="progress-bar bg-success" role="progressbar" :style="'width:'+item[att.attributeName]+'%; background:'+organizationData.colorSeriesA[0]+'!important; color:'+organizationData.colorSeriesA[1]+'!important;'" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">{{item[att.attributeName]}}%</div>
                            </div>
                          </span>
                          <span v-else-if="att.format == 'currency'"> 
                            <span v-if="item[att.attributeName] == '' || item[att.attributeName] == 'undefined' || item[att.attributeName] == undefined" > --.-- </span>
                            <span v-else> {{(JSON.parse(item[att.attributeName])).toLocaleString('en-US', { style: 'currency', currency: 'USD'}) }} </span>
                          </span>
                          <span v-else-if="att.format == 'Date'"> 
                            <span style="display:none;"> {{item[att.attributeName]}}</span>
                            {{ formatData('date',item[att.attributeName])[0]}} <br> {{ formatData('date',item[att.attributeName])[1]}}
                          </span>
                          <span v-else-if="att.attributeName == 'phoneNumber'"> 
                            {{ (item[att.attributeName])}}
                          </span>
                          <span v-else-if="att.attributeType == 'Boolean'"> 
                            <i v-if="item[att.attributeName] == true" class='bx bxs-check-circle' :style="'color:'+organizationData.colorSeriesA[0]+'; font-size:25px; opacity:0.9;'"></i>
                          </span>
                          <span v-else> 
                            {{ item[att.attributeName] }}   
                          </span>
                        </span>
                        <br v-show="item[att.attributeName] != ''">
                      </span>
                    </td>
                    <td data-toggle="modal" data-target="#modal-update" v-on:click="setgRecord([item, 'update']);f_emailTemplates('list',item.PK , item.SK, item )" style="font-size: 12px;"> {{item[entities[item.shortEntity]['metaEntity.sortField3']]}}</td>
                    <td data-toggle="modal" data-target="#modal-update" v-on:click="setgRecord([item, 'update']);f_emailTemplates('list',item.PK , item.SK, item )" style="font-size: 12px;"> {{item[entities[item.shortEntity]['metaEntity.sortField4']]}} </td>
                    <td data-toggle="modal" data-target="#modal-update" v-on:click="setgRecord([item, 'update']);f_emailTemplates('list',item.PK , item.SK, item )" style="font-size: 12px;">
                      <p><strong>Users Can Read</strong></p>
                      <p v-for="(permit, pindex) in item.usersCanRead" :key="pindex" >&nbsp;- {{permit}} </p> 
                      <p><strong>Users Can Edit</strong></p>
                      <p v-for="(permit, pindex) in item.usersCanEdit" :key="pindex" >&nbsp;- {{permit}} </p> 
                    </td>
                    <td class="options-td">
                      <div class="options">   
                        <router-link v-if="item.shortEntity == 'MPR'"  :to="{ paht:'/posts', query:{name: 'posts', data:item.SK}}" style="cursor: pointer"  data-placement="top" target="_blank" > 
                          <ui-accion-button action="post"/>
                        </router-link>
                        <div class="dropdown show" v-if="entities[item.shortEntity] ">
                          <a v-if="JSON.parse(entities[item.shortEntity]['SML.descendantEntitiesWithForm']).length != 0" href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" title="Action">
                            <ui-accion-button action="action"/>
                          </a>
                          <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                            <a class="dropdown-item" style="cursor: pointer; overflow:hidden;"  v-for="(action, aindex) in JSON.parse(entities[item.shortEntity]['SML.descendantEntitiesWithForm'])" :key="aindex"  v-on:click=" setgRecord([item, 'action',aindex]);" data-toggle="modal" data-target="#modal-update">
                              <ui-accion-button v-if="action['metaEntity.descendantEntities'].id && action['metaEntity.descendantEntities'].id.length == 3 && entities[action['metaEntity.descendantEntities'].id].icon">
                                <img :src="JSON.parse(entities[action['metaEntity.descendantEntities'].id].icon)[0].url" alt="">
                              </ui-accion-button>
                              <span v-if="action['metaEntity.descendantEntities'].SK =='#ENT#f9910928-2e9d-4e4b-9a43-19fc1ead11a1'" style="padding: 6px 0; display: block;">
                                &nbsp;{{action['modules.formSK'].value}}
                              </span>
                              <span v-else style="padding: 6px 0; display: block;">
                                &nbsp;{{action['metaEntity.descendantEntities'].value}}
                              </span>
                            </a>
                          </div>
                        </div>
                        <a v-if="item.shortEntity == 'CON'" style="cursor: pointer"  v-on:click="f_emailTemplates('list',item.PK , item.SK, item )"  data-toggle="tooltip" data-placement="top" title="Tooltip on top"> 
                          <ui-accion-button action="send" data-toggle="modal" data-target="#modal-send"/>
                        </a>
                        <a style="cursor: pointer"  v-on:click="setgRecord([item, 'email'])">
                          <ui-accion-button action="send"/>
                        </a>
                        <a style="cursor: pointer" v-if="item.shortEntity == 'PHO' || item.shortEntity == 'PHC'"  v-on:click="setgRecord([item, 'sms'])" >
                          <ui-accion-button action="sms"/>
                        </a>
                        <a v-if="item.shortEntity == 'CON' || item.shortEntity == 'EML'" style="cursor: pointer"  v-on:click="userCreated(item)">
                          <ui-accion-button action="user"/>
                        </a>
                        <a  v-if="item.shortEntity == 'QUO'" :href="organizationData.publicAliasURL+'/checkout?data='+item.SK.replace('#','%23')" target="_blank">
                          <ui-accion-button action="checkout" style="height: 35px; padding: 8px;"/>
                        </a>
                        <router-link v-if="item.shortEntity == 'INF'"  :to=" {paht:'/questionnaires', name:'Questionnaires', query: { data:item.SK }}"  target="_blank"  >
                          <ui-accion-button action="clipboard"/>
                        </router-link>
                        <a style="cursor: pointer" v-on:click="setFavorite(item.PK, item.SK)" >
                          <ui-accion-button action="favorite"/>
                        </a>
                        <a style="cursor: pointer" v-on:click="setClone(item.PK, item.SK)" >
                          <ui-accion-button action="clone"/>
                        </a>
                        <!-- State Record Management -->
                        <a v-if="item.active == '0' || item.active == '1'" style="cursor: pointer" data-toggle="modal" data-target="#modal-status" v-on:click="setgRecord([item, 'status', 'Archive'])" >
                          <ui-accion-button action="archive"/>                                                                                                                                                                                                                                                           
                        </a>
                        <a v-if="item.active == '2' " style="cursor: pointer" data-toggle="modal" data-target="#modal-status" v-on:click="setgRecord([item, 'status', 'Active'])" >
                          <ui-accion-button action="desarchive"/>
                        </a>
                        <a v-if="(item.active == '0' || item.active == '2') && item.PK != '#SMARTDASH'" style="cursor: pointer" data-toggle="modal" data-target="#modal-status" v-on:click="setgRecord([item, 'status', 'Active'])" >
                          <ui-accion-button action="delete" />
                        </a>
                        <a v-if="item.active == '1' && item.PK != '#SMARTDASH'" style="cursor: pointer" data-toggle="modal" data-target="#modal-status" v-on:click="setgRecord([item, 'status', 'Delete'])" >
                          <ui-accion-button action="delete" />
                        </a>
                      </div>
                    </td>
                  </tr>
                </template>
              </ui-table>
              <ui-table v-else-if="focusEntity == 'COMMUNICATION'"> 
                <template #head>
                  <th class="index" :style="'background:'+organizationData.colorSeriesA[0]+';'"></th>
                  <th>#</th>
                  <th>Created At</th>
                  <th>Attributes</th>
                  <th>Status</th>
                  <th></th>
                  <th>Permissions</th>
                  <th>Actions</th>
                </template>
                <template #body  >
                  
                  <tr v-for="(item, index) in tableRecords.ram.splice( pagination.position, pagination.display)" :key="index" style="cursor:pointer;" class="tr-hover" > 
                    <td :style="'background:'+organizationData.colorSeriesA[0]+';'" data-toggle="modal" data-target="#modal-update" v-on:click="setgRecord([item, 'update']);f_emailTemplates('list',item.PK , item.SK, item )"  class="index contact"> 
                      <div class="options" v-if="entities[item.shortEntity].icon">
                        <img style="width:20px; height: 20px;"  :src="JSON.parse(entities[item.shortEntity].icon)[0].url" alt="">
                      </div>
                    </td>
                    <td data-toggle="modal" data-target="#modal-update" v-on:click="setgRecord([item, 'update']);f_emailTemplates('list',item.PK , item.SK, item )" style="font-size: 12px;">{{item.friendlyId}}</td>
                    <td data-toggle="modal" data-target="#modal-update" v-on:click="setgRecord([item, 'update']);f_emailTemplates('list',item.PK , item.SK, item )" style="font-size: 12px;"> {{formatData('date',item.createdAt)[0]}} <br> {{formatData('date',item.createdAt)[1]}} </td>
                    <td data-toggle="modal" data-target="#modal-update" v-on:click="setgRecord([item, 'update']);f_emailTemplates('list',item.PK , item.SK, item )" >
                      <strong>{{item.entityName}}</strong> <br>
                      <span v-show="typeof checkAttribute(att) == 'object'" v-for="(att, zindex) in formatData('JSON',modules[item.shortEntity].dashAttributes)" :key="zindex" style="font-size: 12px;">
                        <strong v-if="att.label != ''" v-show="item[att.attributeName] != ''">{{att.label+': '}}</strong>
                        <span v-show="item[att.attributeName] != ''" v-if="typeof item[att.attributeName] == 'object'"  >
                          <span v-for="(dataItem, dataindex) in item[att.attributeName]" :key="dataindex" >
                            <span v-if="dataindex != 'PK' && dataindex != 'SK'">
                              <span v-if="typeof dataItem == 'object' " >
                                <span  v-for="(key, xindex) in dataItem" :key="xindex">
                                {{key}}
                                </span>
                              </span>
                              <span v-if="typeof dataItem == 'string'"> 
                                {{ dataItem }} 
                              </span>
                            </span>
                          </span>
                        </span>
                        <span v-show="item[att.attributeName] != ''" v-else > 
                          <span v-if="att.inputType == '' || att.inputType == 'preloadList'"> 
                            <span v-for="(xitem, xindex) in item[att.attributeName]" :key="xindex" >
                              <span v-if="xindex != 'PK' && zindex != 'SK'"> 
                                {{xitem}}
                              </span>
                            </span>
                          </span>
                          <span v-else-if="att.inputType == 'range' && item[att.attributeName]">
                            <div class="progress" :style="'background:'+organizationData.colorSeriesA[1]+'!important;'">
                              <div class="progress-bar bg-success" role="progressbar" :style="'width:'+item[att.attributeName]+'%; background:'+organizationData.colorSeriesA[0]+'!important; color:'+organizationData.colorSeriesA[1]+'!important;'" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">{{item[att.attributeName]}}%</div>
                            </div>
                          </span>
                          <span v-else-if="att.format == 'currency'"> 
                            <span v-if="item[att.attributeName] == '' || item[att.attributeName] == 'undefined' || item[att.attributeName] == undefined" > --.-- </span>
                            <span v-else> {{(JSON.parse(item[att.attributeName])).toLocaleString('en-US', { style: 'currency', currency: 'USD'}) }} </span>
                          </span>
                          <span v-else-if="att.format == 'Date'"> 
                            <span style="display:none;"> {{item[att.attributeName]}}</span>
                            {{ formatData('date',item[att.attributeName])[0]}} <br> {{ formatData('date',item[att.attributeName])[1]}}
                          </span>
                          <span v-else-if="att.attributeName == 'phoneNumber'"> 
                            {{ (item[att.attributeName])}}
                          </span>
                          <span v-else-if="att.attributeType == 'Boolean'"> 
                            <i v-if="item[att.attributeName] == true" class='bx bxs-check-circle' :style="'color:'+organizationData.colorSeriesA[0]+'; font-size:25px; opacity:0.9;'"></i>
                          </span>
                          <span v-else> 
                            {{ item[att.attributeName] }}   
                          </span>
                        </span>
                        <br v-show="item[att.attributeName] != ''">
                      </span>
                    </td>
                    <td data-toggle="modal" data-target="#modal-update" v-on:click="setgRecord([item, 'update']);f_emailTemplates('list',item.PK , item.SK, item )" style="font-size: 12px;"> {{item[entities[item.shortEntity]['metaEntity.sortField3']]}}</td>
                    <td data-toggle="modal" data-target="#modal-update" v-on:click="setgRecord([item, 'update']);f_emailTemplates('list',item.PK , item.SK, item )" style="font-size: 12px;"> {{item[entities[item.shortEntity]['metaEntity.sortField4']]}} </td>
                    <td data-toggle="modal" data-target="#modal-update" v-on:click="setgRecord([item, 'update']);f_emailTemplates('list',item.PK , item.SK, item )" style="font-size: 12px;">
                      <p><strong>Users Can Read</strong></p>
                      <p v-for="(permit, pindex) in item.usersCanRead" :key="pindex" >&nbsp;- {{permit}} </p> 
                      <p><strong>Users Can Edit</strong></p>
                      <p v-for="(permit, pindex) in item.usersCanEdit" :key="pindex" >&nbsp;- {{permit}} </p> 
                    </td>
                    <td class="options-td">
                      <div class="options">   
                        <router-link v-if="item.shortEntity == 'MPR'"  :to="{ paht:'/posts', query:{name: 'posts', data:item.SK}}" style="cursor: pointer"  data-placement="top" target="_blank" > 
                          <ui-accion-button action="post"/>
                        </router-link>
                        <div class="dropdown show" v-if="entities[item.shortEntity] ">
                          <a v-if="JSON.parse(entities[item.shortEntity]['SML.descendantEntitiesWithForm']).length != 0" href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" title="Action">
                            <ui-accion-button action="action"/>
                          </a>
                          <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                            <a class="dropdown-item" style="cursor: pointer; overflow:hidden;"  v-for="(action, aindex) in JSON.parse(entities[item.shortEntity]['SML.descendantEntitiesWithForm'])" :key="aindex"  v-on:click=" setgRecord([item, 'action',aindex]);" data-toggle="modal" data-target="#modal-update">
                              <ui-accion-button v-if="action['metaEntity.descendantEntities'].id && action['metaEntity.descendantEntities'].id.length == 3 && entities[action['metaEntity.descendantEntities'].id].icon">
                                <img :src="JSON.parse(entities[action['metaEntity.descendantEntities'].id].icon)[0].url" alt="">
                              </ui-accion-button>
                              <span v-if="action['metaEntity.descendantEntities'].SK =='#ENT#f9910928-2e9d-4e4b-9a43-19fc1ead11a1'" style="padding: 6px 0; display: block;">
                                &nbsp;{{action['modules.formSK'].value}}
                              </span>
                              <span v-else style="padding: 6px 0; display: block;">
                                &nbsp;{{action['metaEntity.descendantEntities'].value}}
                              </span>
                            </a>
                          </div>
                        </div>
                        <a v-if="item.shortEntity == 'CON'" style="cursor: pointer"  v-on:click="f_emailTemplates('list',item.PK , item.SK, item )"  data-toggle="tooltip" data-placement="top" title="Tooltip on top"> 
                          <ui-accion-button action="send" data-toggle="modal" data-target="#modal-send"/>
                        </a>
                        <a style="cursor: pointer"  v-on:click="setgRecord([item, 'email'])">
                          <ui-accion-button action="send"/>
                        </a>
                        <a style="cursor: pointer" v-if="item.shortEntity == 'PHO' || item.shortEntity == 'PHC'"  v-on:click="setgRecord([item, 'sms'])" >
                          <ui-accion-button action="sms"/>
                        </a>
                        <a v-if="item.shortEntity == 'CON' || item.shortEntity == 'EML'" style="cursor: pointer"  v-on:click="userCreated(item)">
                          <ui-accion-button action="user"/>
                        </a>
                        <a  v-if="item.shortEntity == 'QUO'" :href="organizationData.publicAliasURL+'/checkout?data='+item.SK.replace('#','%23')" target="_blank">
                          <ui-accion-button action="checkout" style="height: 35px; padding: 8px;"/>
                        </a>
                        <router-link v-if="item.shortEntity == 'INF'"  :to=" {paht:'/questionnaires', name:'Questionnaires', query: { data:item.SK }}"  target="_blank"  >
                          <ui-accion-button action="clipboard"/>
                        </router-link>
                        <a style="cursor: pointer" v-on:click="setFavorite(item.PK, item.SK)" >
                          <ui-accion-button action="favorite"/>
                        </a>
                        <a style="cursor: pointer" v-on:click="setClone(item.PK, item.SK)" >
                          <ui-accion-button action="clone"/>
                        </a>
                        <!-- State Record Management -->
                        <a v-if="item.active == '0' || item.active == '1'" style="cursor: pointer" data-toggle="modal" data-target="#modal-status" v-on:click="setgRecord([item, 'status', 'Archive'])" >
                          <ui-accion-button action="archive"/>                                                                                                                                                                                                                                                           
                        </a>
                        <a v-if="item.active == '2' " style="cursor: pointer" data-toggle="modal" data-target="#modal-status" v-on:click="setgRecord([item, 'status', 'Active'])" >
                          <ui-accion-button action="desarchive"/>
                        </a>
                        <a v-if="(item.active == '0' || item.active == '2') && item.PK != '#SMARTDASH'" style="cursor: pointer" data-toggle="modal" data-target="#modal-status" v-on:click="setgRecord([item, 'status', 'Active'])" >
                          <ui-accion-button action="delete" />
                        </a>
                        <a v-if="item.active == '1' && item.PK != '#SMARTDASH'" style="cursor: pointer" data-toggle="modal" data-target="#modal-status" v-on:click="setgRecord([item, 'status', 'Delete'])" >
                          <ui-accion-button action="delete" />
                        </a>
                      </div>
                    </td>
                  </tr>
                </template>
              </ui-table>
              <ui-table v-else> 
                <template #head v-if="modules[tableRecords.entities[eindex]]">
                  <th class="index" :style="'background:'+organizationData.colorSeriesA[0]+';'"></th>
                  <th v-for="(entity, eindex) in JSON.parse(modules[tableRecords.entities[eindex]].headers)" :key="eindex">{{entity.label}}</th>
                  <th>Actions</th> 
                </template>
                <template #body v-if="modules[tableRecords.entities[eindex]]">
                  <tr v-for="(item, index) in tableRecords.ram" :key="index" style="cursor:pointer;" class="tr-hover" > 
                    <td :style="'background:'+organizationData.colorSeriesA[0]+';'" data-toggle="modal" data-target="#modal-update" v-on:click="setgRecord([item, 'update']);f_emailTemplates('list',item.PK , item.SK, item )"  class="index contact"> 
                      <div class="options" v-if="entities[item.shortEntity].icon">
                        <img style="width:20px; height: 20px;"  :src="JSON.parse(entities[item.shortEntity].icon)[0].url" alt="">
                      </div>
                    </td>
                    <td 
                      data-toggle="modal" 
                      data-target="#modal-update" 
                      v-on:click="setgRecord([item, 'update']);f_emailTemplates('list',item.PK , item.SK, item )" 
                      style="font-size: 12px;"
                      v-for="(head, eindex) in JSON.parse(modules[tableRecords.entities[eindex]].headers)" :key="eindex"
                    >
                      <span v-if="head.inputType &&  item[head.attributeName] &&  head.inputType.toLowerCase() == 'date'">
                        {{formatData('date', item[head.attributeName])[0]}}
                        <br>
                        {{formatData('date', item[head.attributeName])[1]}}
                      </span>
                      <span v-else-if="head.inputType && head.inputType.toLowerCase() == 'range'">
                        <div class="progress" :style="'background:'+organizationData.colorSeriesA[1]+'!important;'">
                        <div class="progress-bar bg-success" role="progressbar" :style="'width:'+item[head.attributeName]+'%; background:'+organizationData.colorSeriesA[0]+'!important; color:'+organizationData.colorSeriesA[1]+'!important;'" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">{{item[head.attributeName]}}%</div>
                        </div>
                      </span>
                      <span v-else-if="head.inputType && head.inputType.toLowerCase() == 'boolean'">
                        <i v-if="item[head.attributeName] == true" class='bx bxs-check-circle' :style="'color:'+organizationData.colorSeriesA[0]+'; font-size:25px; opacity:0.9;'"></i>
                      </span>
                      <span v-else-if="head.inputType && head.inputType.toLowerCase() == 'currency'">
                        {{formatData('currency', item[head.attributeName])}} 
                      </span>
                      <span :id="'cell-'+head.attributeName+'-'+rIndex" v-else-if="head.inputType && head.inputType.toLowerCase() == 'html'">
                        {{formatData('html', [ item[head.attributeName], 'cell-'+head.attributeName+'-'+rIndex])}} 
                      </span>
                      <span v-else-if="head.inputType && head.inputType.toLowerCase() == 'phone'" class="absoluteCenterFlex">
                        <span title="Open Virtual Phone">
                          <svg  class="hoverOpacity" style="margin:0 10px 0 0;" v-on:click="openPhone()" xmlns="http://www.w3.org/2000/svg" width="25" height="25" preserveAspectRatio="xMidYMid meet" viewBox="0 0 32 32"><path fill="#333" d="M24 13h-2a3.003 3.003 0 0 0-3-3V8a5.006 5.006 0 0 1 5 5Z"/><path fill="#333" d="M28 13h-2a7.008 7.008 0 0 0-7-7V4a9.01 9.01 0 0 1 9 9zm-7.667 8.482l2.24-2.24a2.167 2.167 0 0 1 2.337-.48l2.728 1.092A2.167 2.167 0 0 1 29 21.866v4.961a2.167 2.167 0 0 1-2.284 2.169C7.594 27.806 3.732 11.61 3.015 5.408A2.162 2.162 0 0 1 5.169 3h4.873a2.167 2.167 0 0 1 2.012 1.362l1.091 2.728a2.167 2.167 0 0 1-.48 2.337l-2.24 2.24s1.242 8.732 9.908 9.815z"/></svg>
                        </span>
                        <span title="Copy Phone Number">
                          {{formatData('phone', item[head.attributeName])}} 
                        </span>
                      </span>
                      <span v-else-if="head.inputType == 'file'" class="absoluteCenterFlex">
                        <span  v-for="(file, index) in item[head.attributeName]" :key="index">  
                          <img :src="file.url" :alt="file.url" :style="head.style">
                        </span>
                      </span>
                      <span v-else-if="head.attributeName == 'layout'" class="absoluteCenterFlex">
                        {{item[head.attributeName].value}} 
                      </span>
                      <span v-else>
                        {{item[head.attributeName]}}
                      </span>
                    </td>
                    <td class="options-td">
                      <div class="options">   
                        <router-link v-if="item.shortEntity == 'MPR'"  :to="{ paht:'/posts', query:{name: 'posts', data:item.SK}}" style="cursor: pointer"  data-placement="top" target="_blank" > 
                          <ui-accion-button action="post"/>
                        </router-link>
                        <div class="dropdown show" v-if="entities[item.shortEntity] ">
                          <a v-if="JSON.parse(entities[item.shortEntity]['SML.descendantEntitiesWithForm']).length != 0" href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" title="Action">
                            <ui-accion-button action="action"/>
                          </a>
                          <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                            <a class="dropdown-item" style="cursor: pointer; overflow:hidden;"  v-for="(action, aindex) in JSON.parse(entities[item.shortEntity]['SML.descendantEntitiesWithForm'])" :key="aindex"  v-on:click=" setgRecord([item, 'action',aindex]);" data-toggle="modal" data-target="#modal-update">
                              <ui-accion-button v-if="action['metaEntity.descendantEntities'].id && action['metaEntity.descendantEntities'].id.length == 3 && entities[action['metaEntity.descendantEntities'].id].icon">
                                <img :src="JSON.parse(entities[action['metaEntity.descendantEntities'].id].icon)[0].url" alt="">
                              </ui-accion-button>
                              <span v-if="action['metaEntity.descendantEntities'].SK =='#ENT#f9910928-2e9d-4e4b-9a43-19fc1ead11a1'" style="padding: 6px 0; display: block;">
                                &nbsp;{{action['modules.formSK'].value}}
                              </span>
                              <span v-else style="padding: 6px 0; display: block;">
                                &nbsp;{{action['metaEntity.descendantEntities'].value}}
                              </span>
                            </a>
                          </div>
                        </div>
                        <a v-if="item.shortEntity == 'CON'" style="cursor: pointer"  v-on:click="f_emailTemplates('list',item.PK , item.SK, item )"  data-toggle="tooltip" data-placement="top" title="Tooltip on top"> 
                          <ui-accion-button action="send" data-toggle="modal" data-target="#modal-send"/>
                        </a>
                        <a style="cursor: pointer"  v-on:click="setgRecord([item, 'email'])">
                          <ui-accion-button action="send"/>
                        </a>
                        <a style="cursor: pointer" v-if="item.shortEntity == 'PHO' || item.shortEntity == 'PHC'"  v-on:click="setgRecord([item, 'sms'])" >
                          <ui-accion-button action="sms"/>
                        </a>
                        <a v-if="item.shortEntity == 'CON' || item.shortEntity == 'EML'" style="cursor: pointer"  v-on:click="userCreated(item)">
                          <ui-accion-button action="user"/>
                        </a>
                        <a  v-if="item.shortEntity == 'QUO'" :href="organizationData.publicAliasURL+'/checkout?data='+item.SK.replace('#','%23')" target="_blank">
                          <ui-accion-button action="checkout" style="height: 35px; padding: 8px;"/>
                        </a>
                        <router-link v-if="item.shortEntity == 'INF'"  :to=" {paht:'/questionnaires', name:'Questionnaires', query: { data:item.SK }}"  target="_blank"  >
                          <ui-accion-button action="clipboard"/>
                        </router-link>
                        <a style="cursor: pointer" v-on:click="setFavorite(item.PK, item.SK)" >
                          <ui-accion-button action="favorite"/>
                        </a>
                        <a style="cursor: pointer" v-on:click="setClone(item.PK, item.SK)" >
                          <ui-accion-button action="clone"/>
                        </a>
                        <!-- State Record Management -->
                        <a v-if="item.active == '0' || item.active == '1'" style="cursor: pointer" data-toggle="modal" data-target="#modal-status" v-on:click="setgRecord([item, 'status', 'Archive'])" >
                          <ui-accion-button action="archive"/>                                                                                                                                                                                                                                                           
                        </a>
                        <a v-if="item.active == '2' " style="cursor: pointer" data-toggle="modal" data-target="#modal-status" v-on:click="setgRecord([item, 'status', 'Active'])" >
                          <ui-accion-button action="desarchive"/>
                        </a>
                        <a v-if="(item.active == '0' || item.active == '2') && item.PK != '#SMARTDASH'" style="cursor: pointer" data-toggle="modal" data-target="#modal-status" v-on:click="setgRecord([item, 'status', 'Active'])" >
                          <ui-accion-button action="delete" />
                        </a>
                        <a v-if="item.active == '1' && item.PK != '#SMARTDASH'" style="cursor: pointer" data-toggle="modal" data-target="#modal-status" v-on:click="setgRecord([item, 'status', 'Delete'])" >
                          <ui-accion-button action="delete" />
                        </a>
                      </div>
                    </td>
                  </tr>
                </template>
              </ui-table>
              <div class="table-wrap" v-if="false">
                <div class="pagination">
                  <a href="#" v-show="table.pagination[2] != 1" v-on:click="table.pagination[2] = table.pagination[2]-1; table.pagination[1] = (table.pagination[2]-1)*table.pageSize;f_RenderComponent();">&laquo;</a>
                  <a href="#" :class="{ active: table.pagination[2] == index+1}" :id="'pagination-'+index" v-for="(item, index) in table.pagination[0]" :key="index" v-on:click="  table.pagination[1] = (index)*table.pageSize; table.pagination[2] =index+1;f_RenderComponent();" > {{ index+1 }} </a>
                  <a href="#" v-show="table.pagination[2] != table.pagination[0]" v-on:click="table.pagination[1] = (table.pagination[2])*table.pageSize; table.pagination[2] = table.pagination[2]+1; f_RenderComponent();">&raquo;</a>
                </div>
                <!--ul class="list-group">
                  <li class="list-group-item" v-for="(item, rIndex) in table.ram" :key="rIndex">{{item['sml.contactFullName']}}</li>
                </ul-->
                <ui-table>
                  <template #head>
                    <th class="index">
                      <span>
                        <input style="width: 20px; height: 20px;" type="checkbox" name="" id="" v-on:change="(event)=>{ selectItemsTable(event, 'all') } ">
                      </span>
                    </th>
                    <th v-for="(head, hIndex) in table.headers" :key="hIndex" v-on:click="()=>{ table.headers[hIndex].order = !table.headers[hIndex].order; sortTable(hIndex+1)}"> 
                      {{head.label}}
                    </th>
                    <th v-if="!this.userPermissions.includes('Guest')" >options</th>
                  </template>
                  <template #body>
                    <tr class="tr-hover" v-for="(item, rIndex) in table.ram.slice(table.pagination[1], table.pagination[1]+table.pageSize )" :key="rIndex">
                      <td class="index">  
                        <span v-if="item.subscribe">
                          <i v-if="item.subscribe == 'edit'" class='bx bxs-pencil' style='color:#5ad911'></i>
                          <i v-if="item.subscribe == 'new'" class='bx bxs-star' style='color:#0085ff'  ></i>
                        </span>
                        <span >
                          {{rIndex+1}}
                        </span>
                        <span>
                          <input :id="rIndex+item.SK" style="width: 20px; height: 20px;" type="checkbox" name="" id="" v-on:change="(event)=>{ selectItemsTable(event, 'select', item) } ">
                        </span>
                      </td>
                      <td v-for="(head, hIndex) in table.headers" :style="head.style" :key="hIndex" v-on:click="actionRecord(item, 'update', head)" style="overflow: hidden;">
                        <!--p v-if="head.value && renderComponent"  v-for="(shead, sIndex) in head.value" :key="sIndex" v-on:click="actionRecord(item)">
                          <span v-if="item[shead.attributeName] != ''" style="display:block;">
                            <strong v-if="shead.label && shead.label != ''">{{shead.label}}</strong> 
                            <ui-recursive-display :vdata="item[shead.attributeName]" :format="shead.inputType" :id="'cell-'+shead.attributeName+'-'+rIndex" type="combo" :name="shead.attributeName"/>
                          </span>
                        </!--p>
                        <ui-recursive-display v-if="!head.value && renderComponent" :vdata="item[head.attributeName]" :format="head.inputType" :id="'cell-'+head.attributeName+'-'+rIndex" :name="head.attributeName"/-->
                        <span v-if="head.inputType &&  item[head.attributeName] &&  head.inputType.toLowerCase() == 'date'">
                          {{formatData('date', item[head.attributeName])[0]}}
                          <br>
                          {{formatData('date', item[head.attributeName])[1]}}
                        </span>
                        <span v-else-if="head.inputType && head.inputType.toLowerCase() == 'range'">
                          <div class="progress" :style="'background:'+organizationData.colorSeriesA[1]+'!important;'">
                          <div class="progress-bar bg-success" role="progressbar" :style="'width:'+item[head.attributeName]+'%; background:'+organizationData.colorSeriesA[0]+'!important; color:'+organizationData.colorSeriesA[1]+'!important;'" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">{{item[head.attributeName]}}%</div>
                          </div>
                        </span>
                        <span v-else-if="head.inputType && head.inputType.toLowerCase() == 'boolean'">
                          <i v-if="item[head.attributeName] == true" class='bx bxs-check-circle' :style="'color:'+organizationData.colorSeriesA[0]+'; font-size:25px; opacity:0.9;'"></i>
                        </span>
                        <span v-else-if="head.inputType && head.inputType.toLowerCase() == 'currency'">
                          {{formatData('currency', item[head.attributeName])}} 
                        </span>
                        <span :id="'cell-'+head.attributeName+'-'+rIndex" v-else-if="head.inputType && head.inputType.toLowerCase() == 'html'">
                          {{formatData('html', [ item[head.attributeName], 'cell-'+head.attributeName+'-'+rIndex])}} 
                        </span>
                        <span v-else-if="head.inputType && head.inputType.toLowerCase() == 'phone'" class="absoluteCenterFlex">
                          <span title="Open Virtual Phone">
                            <svg  class="hoverOpacity" style="margin:0 10px 0 0;" v-on:click="openPhone()" xmlns="http://www.w3.org/2000/svg" width="25" height="25" preserveAspectRatio="xMidYMid meet" viewBox="0 0 32 32"><path fill="#333" d="M24 13h-2a3.003 3.003 0 0 0-3-3V8a5.006 5.006 0 0 1 5 5Z"/><path fill="#333" d="M28 13h-2a7.008 7.008 0 0 0-7-7V4a9.01 9.01 0 0 1 9 9zm-7.667 8.482l2.24-2.24a2.167 2.167 0 0 1 2.337-.48l2.728 1.092A2.167 2.167 0 0 1 29 21.866v4.961a2.167 2.167 0 0 1-2.284 2.169C7.594 27.806 3.732 11.61 3.015 5.408A2.162 2.162 0 0 1 5.169 3h4.873a2.167 2.167 0 0 1 2.012 1.362l1.091 2.728a2.167 2.167 0 0 1-.48 2.337l-2.24 2.24s1.242 8.732 9.908 9.815z"/></svg>
                          </span>
                          <span title="Copy Phone Number">
                            {{formatData('phone', item[head.attributeName])}} 
                          </span>
                        </span>
                        <span v-else-if="head.inputType == 'file'" class="absoluteCenterFlex">
                          <span  v-for="(file, index) in item[head.attributeName]" :key="index">  
                            <img :src="file.url" :alt="file.url" :style="head.style">
                          </span>
                        </span>
                        <span v-else-if="head.attributeName == 'layout'" class="absoluteCenterFlex">
                          {{item[head.attributeName].value}} 
                        </span>
                        <span v-else>
                          {{item[head.attributeName]}}
                        </span>
                      </td>
                      <td v-if="!this.userPermissions.includes('Guest')" class="options-td">
                        <div class="options">   
                          <div class="dropdown show" v-if="entities[dataModule['modules.dataQuery']]">
                            <a href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" title="Action">
                              <ui-accion-button action="action"/>
                            </a>
                            <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                              <a class="dropdown-item" style="cursor: pointer; overflow:hidden;"  v-for="(action, aindex) in JSON.parse(entities[dataModule['modules.dataQuery']]['SML.descendantEntitiesWithForm'])" :key="aindex"  v-on:click=" setgRecord([item, 'action',aindex]);" data-toggle="modal" data-target="#modal-update">
                                
                                <ui-accion-button v-if="action['metaEntity.descendantEntities'].id && action['metaEntity.descendantEntities'].id.length == 3 && entities[action['metaEntity.descendantEntities'].id].icon">
                                    <img :src="JSON.parse(entities[action['metaEntity.descendantEntities'].id].icon)[0].url" alt="">
                                  </ui-accion-button>
                                <span v-if="action['metaEntity.descendantEntities'].SK =='#ENT#f9910928-2e9d-4e4b-9a43-19fc1ead11a1'" style="padding: 6px 0; display: block;">
                                  &nbsp;{{action['modules.formSK'].value}}
                                </span>
                                <span v-else style="padding: 6px 0; display: block;">
                                  &nbsp;{{action['metaEntity.descendantEntities'].value}}
                                </span>
                              </a>
                            </div>
                          </div>
                          <!-- Action Records -->
                          <router-link v-if="this.pageQuery == 'MPR'"  :to=" { path:'/smartmaker',query: { name:'SMLUP', PK:item.layout.PK, SK:item.layout.SK, post:item.SK} }" style="cursor: pointer"  data-placement="top" target="_blank" > 
                            <div class="col send">
                              <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" width="1em" height="1em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 16 16"><path fill="white" d="M2 6a6 6 0 1 1 10.174 4.31c-.203.196-.359.4-.453.619l-.762 1.769A.5.5 0 0 1 10.5 13h-5a.5.5 0 0 1-.46-.302l-.761-1.77a1.964 1.964 0 0 0-.453-.618A5.984 5.984 0 0 1 2 6zm3 8.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1l-.224.447a1 1 0 0 1-.894.553H6.618a1 1 0 0 1-.894-.553L5.5 15a.5.5 0 0 1-.5-.5z"/></svg>
                            </div>
                          </router-link>
                          <router-link v-if="pageQuery == 'BLO' || pageQuery == 'WEB' || pageQuery == 'PRO'"  :to=" { path:'/smarpage',query: { PK:item.PK, SK:item.SK} }" style="cursor: pointer"  data-placement="top" target="_blank" > 
                            <div class="col send">
                              <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" width="1em" height="1em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 16 16"><path fill="white" d="M2 6a6 6 0 1 1 10.174 4.31c-.203.196-.359.4-.453.619l-.762 1.769A.5.5 0 0 1 10.5 13h-5a.5.5 0 0 1-.46-.302l-.761-1.77a1.964 1.964 0 0 0-.453-.618A5.984 5.984 0 0 1 2 6zm3 8.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1l-.224.447a1 1 0 0 1-.894.553H6.618a1 1 0 0 1-.894-.553L5.5 15a.5.5 0 0 1-.5-.5z"/></svg>
                            </div>
                          </router-link>
                          <router-link v-if="this.pageQuery == '#SML'"  :to=" { path:'/smartmaker',query: {  name:'SMLUP', PK:item.PK, SK:item.SK, mode:'generate'}  }" style="cursor: pointer"  data-placement="top" target="_blank" > 
                            <div class="col send">                            
                              <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" width="1em" height="1em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 16 16"><path fill="white" d="M2 6a6 6 0 1 1 10.174 4.31c-.203.196-.359.4-.453.619l-.762 1.769A.5.5 0 0 1 10.5 13h-5a.5.5 0 0 1-.46-.302l-.761-1.77a1.964 1.964 0 0 0-.453-.618A5.984 5.984 0 0 1 2 6zm3 8.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1l-.224.447a1 1 0 0 1-.894.553H6.618a1 1 0 0 1-.894-.553L5.5 15a.5.5 0 0 1-.5-.5z"/></svg>
                            </div>
                          </router-link>
                          <router-link v-if="this.pageQuery == '#SML'"  :to=" { path:'/webpreview',query: {  sml:item.SK,}  }" style="cursor: pointer"  data-placement="top" target="_blank" > 
                            <div class="col send">                    
                              <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24"><path fill="white" d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5s5 2.24 5 5s-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3s3-1.34 3-3s-1.34-3-3-3z"/></svg>
                            </div>
                          </router-link>
                          <a style="cursor: pointer"  data-toggle="modal" data-target="#modal-send"  v-on:click="setgRecord([item, 'email'])">
                            <ui-accion-button action="send"/>
                          </a>
                          <router-link  v-if="item.GSP1PK1" :to="{ paht:'/dashboard', query:{ name: 'clietDash', data: item.GSP1PK1 }}" v-on:click="forceUpdate()">
                            <ui-accion-button action="dash"/>
                          </router-link>
                          <a style="cursor: pointer" v-if="pageQuery == 'PHC' && !item.GSP1PK1" v-on:click="createLead(item)" >
                            <ui-accion-button action="user"/>
                          </a>
                          <a style="cursor: pointer" v-if="pageQuery == 'PHO' || (pageQuery== 'PHC' && item.phoneNumber) || pageQuery== 'CON'"  v-on:click="setgRecord([item, 'sms'])">
                            <ui-accion-button action="sms"/>
                          </a>
                          <a v-if="pageQuery == 'QUO'" :href="organizationData.publicAliasURL+'/checkout?data='+item.SK.replace('#','%23')" target="_blank">
                            <ui-accion-button action="checkout" style="height: 35px; padding: 8px;"/>
                          </a>
                          <a style="cursor: pointer" v-on:click="cloneRecod(item)" >
                            <ui-accion-button action="clone"/>
                          </a>
                          <!-- State Record Management -->
                          <a style="cursor: pointer" v-if="pageQuery == 'USR'" v-on:click="addUser(item)" >
                            <ui-accion-button action="user"/>
                          </a>
                          <!-- State Record Management -->
                          <a v-if="item.active == '0' || item.active == '1'" style="cursor: pointer" data-toggle="modal" data-target="#modal-status" v-on:click="setgRecord([item, 'status', 'Archive'])" >
                            <ui-accion-button action="archive"/>                                                                                                                                                                                                                                                           
                          </a>
                          <a v-if="item.active == '2' " style="cursor: pointer" data-toggle="modal" data-target="#modal-status" v-on:click="setgRecord([item, 'status', 'Active'])" >
                            <ui-accion-button action="desarchive"/>
                          </a>
                          <a v-if="(item.active == '0' || item.active == '2') && item.PK != '#SMARTDASH'" style="cursor: pointer" data-toggle="modal" data-target="#modal-status" v-on:click="setgRecord([item, 'status', 'Active'])" >
                            <ui-accion-button action="delete" />
                          </a>
                          <a v-if="item.active == '1' && item.PK != '#SMARTDASH'" style="cursor: pointer" data-toggle="modal" data-target="#modal-status" v-on:click="setgRecord([item, 'status', 'Delete'])" >
                            <ui-accion-button action="delete" />
                          </a>
                        </div>
                      </td>
                    </tr>
                  </template>
                </ui-table>
                <div class="pagination">
                  <a href="#" v-show="table.pagination[2] != 1" v-on:click="table.pagination[2] = table.pagination[2]-1; table.pagination[1] = (table.pagination[2]-1)*table.pageSize;">&laquo;</a>
                  <a href="#" :class="{ active: table.pagination[2] == index+1}" :id="'pagination-'+index" v-for="(item, index) in table.pagination[0]" :key="index" v-on:click="table.pagination[1] = (index)*table.pageSize; table.pagination[2] =index+1" > {{ index+1 }} </a>
                  <a href="#" v-show="table.pagination[2] != table.pagination[0]" v-on:click="table.pagination[1] = (table.pagination[2])*table.pageSize; table.pagination[2] = table.pagination[2]+1">&raquo;</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ui-table v-if="false">
          <template #head>
            <th class="index" :style="'background:'+organizationData.colorSeriesA[0]+';'"></th>
            <th>#</th>
            <th>Created At</th>
            <th>Attributes</th>
            <th>Status</th>
            <th></th>
            <th>Permissions</th>
            <th>Actions</th>
          </template>
          <template #body>
            <tr v-for="(item, index) in dataTable" :key="index" style="cursor:pointer;" class="tr-hover" > 
              <td :style="'background:'+organizationData.colorSeriesA[0]+';'" data-toggle="modal" data-target="#modal-update" v-on:click="setgRecord([item, 'update']);f_emailTemplates('list',item.PK , item.SK, item )"  class="index contact"> 
                <div class="options" v-if="entities[item.shortEntity].icon">
                  <img style="width:20px; height: 20px;"  :src="JSON.parse(entities[item.shortEntity].icon)[0].url" alt="">
                </div>
              </td>
              <td data-toggle="modal" data-target="#modal-update" v-on:click="setgRecord([item, 'update']);f_emailTemplates('list',item.PK , item.SK, item )" style="font-size: 12px;">{{item.friendlyId}}</td>
              <td data-toggle="modal" data-target="#modal-update" v-on:click="setgRecord([item, 'update']);f_emailTemplates('list',item.PK , item.SK, item )" style="font-size: 12px;"> {{formatData('date',item.createdAt)[0]}} <br> {{formatData('date',item.createdAt)[1]}} </td>
              <td data-toggle="modal" data-target="#modal-update" v-on:click="setgRecord([item, 'update']);f_emailTemplates('list',item.PK , item.SK, item )" >
                <strong>{{item.entityName}}</strong> <br>
                <span v-show="typeof checkAttribute(att) == 'object'" v-for="(att, zindex) in formatData('JSON',modules[item.shortEntity].dashAttributes)" :key="zindex" style="font-size: 12px;">
                  <strong v-if="att.label != ''" v-show="item[att.attributeName] != ''">{{att.label+': '}}</strong>
                  <span v-show="item[att.attributeName] != ''" v-if="typeof item[att.attributeName] == 'object'"  >
                    <span v-for="(dataItem, dataindex) in item[att.attributeName]" :key="dataindex" >
                      <span v-if="dataindex != 'PK' && dataindex != 'SK'">
                        <span v-if="typeof dataItem == 'object' " >
                          <span  v-for="(key, xindex) in dataItem" :key="xindex">
                          {{key}}
                          </span>
                        </span>
                        <span v-if="typeof dataItem == 'string'"> 
                          {{ dataItem }} 
                        </span>
                      </span>
                    </span>
                  </span>
                  <span v-show="item[att.attributeName] != ''" v-else > 
                    <span v-if="att.inputType == '' || att.inputType == 'preloadList'"> 
                      <span v-for="(xitem, xindex) in item[att.attributeName]" :key="xindex" >
                        <span v-if="xindex != 'PK' && zindex != 'SK'"> 
                          {{xitem}}
                        </span>
                      </span>
                    </span>
                    <span v-else-if="att.inputType == 'range' && item[att.attributeName]">
                      <div class="progress" :style="'background:'+organizationData.colorSeriesA[1]+'!important;'">
                        <div class="progress-bar bg-success" role="progressbar" :style="'width:'+item[att.attributeName]+'%; background:'+organizationData.colorSeriesA[0]+'!important; color:'+organizationData.colorSeriesA[1]+'!important;'" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">{{item[att.attributeName]}}%</div>
                      </div>
                    </span>
                    <span v-else-if="att.format == 'currency'"> 
                      <span v-if="item[att.attributeName] == '' || item[att.attributeName] == 'undefined' || item[att.attributeName] == undefined" > --.-- </span>
                      <span v-else> {{(JSON.parse(item[att.attributeName])).toLocaleString('en-US', { style: 'currency', currency: 'USD'}) }} </span>
                    </span>
                    <span v-else-if="att.format == 'Date'"> 
                      <span style="display:none;"> {{item[att.attributeName]}}</span>
                      {{ formatData('date',item[att.attributeName])[0]}} <br> {{ formatData('date',item[att.attributeName])[1]}}
                    </span>
                    <span v-else-if="att.attributeName == 'phoneNumber'"> 
                      {{ (item[att.attributeName])}}
                    </span>
                    <span v-else-if="att.attributeType == 'Boolean'"> 
                      <i v-if="item[att.attributeName] == true" class='bx bxs-check-circle' :style="'color:'+organizationData.colorSeriesA[0]+'; font-size:25px; opacity:0.9;'"></i>
                    </span>
                    <span v-else> 
                      {{ item[att.attributeName] }}   
                    </span>
                  </span>
                  <br v-show="item[att.attributeName] != ''">
                </span>
              </td>
              <td data-toggle="modal" data-target="#modal-update" v-on:click="setgRecord([item, 'update']);f_emailTemplates('list',item.PK , item.SK, item )" style="font-size: 12px;"> {{item[entities[item.shortEntity]['metaEntity.sortField3']]}}</td>
              <td data-toggle="modal" data-target="#modal-update" v-on:click="setgRecord([item, 'update']);f_emailTemplates('list',item.PK , item.SK, item )" style="font-size: 12px;"> {{item[entities[item.shortEntity]['metaEntity.sortField4']]}} </td>
              <td data-toggle="modal" data-target="#modal-update" v-on:click="setgRecord([item, 'update']);f_emailTemplates('list',item.PK , item.SK, item )" style="font-size: 12px;">
                <p><strong>Users Can Read</strong></p>
                <p v-for="(permit, pindex) in item.usersCanRead" :key="pindex" >&nbsp;- {{permit}} </p> 
                <p><strong>Users Can Edit</strong></p>
                <p v-for="(permit, pindex) in item.usersCanEdit" :key="pindex" >&nbsp;- {{permit}} </p> 
              </td>
              <td class="options-td">
                <div class="options">   
                  <router-link v-if="item.shortEntity == 'MPR'"  :to="{ paht:'/posts', query:{name: 'posts', data:item.SK}}" style="cursor: pointer"  data-placement="top" target="_blank" > 
                    <ui-accion-button action="post"/>
                  </router-link>
                  <div class="dropdown show" v-if="entities[item.shortEntity] ">
                    <a v-if="JSON.parse(entities[item.shortEntity]['SML.descendantEntitiesWithForm']).length != 0" href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" title="Action">
                      <ui-accion-button action="action"/>
                    </a>
                    <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                      <a class="dropdown-item" style="cursor: pointer; overflow:hidden;"  v-for="(action, aindex) in JSON.parse(entities[item.shortEntity]['SML.descendantEntitiesWithForm'])" :key="aindex"  v-on:click=" setgRecord([item, 'action',aindex]);" data-toggle="modal" data-target="#modal-update">
                        <ui-accion-button v-if="action['metaEntity.descendantEntities'].id && action['metaEntity.descendantEntities'].id.length == 3 && entities[action['metaEntity.descendantEntities'].id].icon">
                          <img :src="JSON.parse(entities[action['metaEntity.descendantEntities'].id].icon)[0].url" alt="">
                        </ui-accion-button>
                        <span v-if="action['metaEntity.descendantEntities'].SK =='#ENT#f9910928-2e9d-4e4b-9a43-19fc1ead11a1'" style="padding: 6px 0; display: block;">
                          &nbsp;{{action['modules.formSK'].value}}
                        </span>
                        <span v-else style="padding: 6px 0; display: block;">
                          &nbsp;{{action['metaEntity.descendantEntities'].value}}
                        </span>
                      </a>
                    </div>
                  </div>
                  <a v-if="item.shortEntity == 'CON'" style="cursor: pointer"  v-on:click="f_emailTemplates('list',item.PK , item.SK, item )"  data-toggle="tooltip" data-placement="top" title="Tooltip on top"> 
                    <ui-accion-button action="send" data-toggle="modal" data-target="#modal-send"/>
                  </a>
                  <a style="cursor: pointer" data-toggle="modal" data-target="#modal-archive" v-on:click="getItem(item, 'status')">
                    <ui-accion-button action="archive"/>
                  </a>
                  <a style="cursor: pointer"  v-on:click="setgRecord([item, 'email'])">
                    <ui-accion-button action="send"/>
                  </a>
                  <a style="cursor: pointer" v-if="item.shortEntity == 'PHO' || item.shortEntity == 'PHC'"  v-on:click="setgRecord([item, 'sms'])" >
                    <ui-accion-button action="sms"/>
                  </a>
                  <a v-if="item.shortEntity == 'CON' || item.shortEntity == 'EML'" style="cursor: pointer"  v-on:click="userCreated(item)">
                    <ui-accion-button action="user"/>
                  </a>
                  <a  v-if="item.shortEntity == 'QUO'" :href="organizationData.publicAliasURL+'/checkout?data='+item.SK.replace('#','%23')" target="_blank">
                    <ui-accion-button action="checkout" style="height: 35px; padding: 8px;"/>
                  </a>
                  <router-link v-if="item.shortEntity == 'INF'"  :to=" {paht:'/questionnaires', name:'Questionnaires', query: { data:item.SK }}"  target="_blank"  >
                    <ui-accion-button action="clipboard"/>
                  </router-link>
                  <a style="cursor: pointer" v-on:click="setFavorite(item.PK, item.SK)" >
                    <ui-accion-button action="favorite"/>
                  </a>
                  <a style="cursor: pointer" v-on:click="setClone(item.PK, item.SK)" >
                    <ui-accion-button action="clone"/>
                  </a>
                  <a style="cursor: pointer" data-toggle="modal" data-target="#modal-active" v-on:click="getItem(item, 'status')">
                    <div class="col delete">
                      <svg width="78" height="100" viewBox="0 0 78 100" fill="none" >
                        <path d="M5.57143 88.8889C5.57143 95 10.5857 100 16.7143 100H61.2857C67.4143 100 72.4286 95 72.4286 88.8889V22.2222H5.57143V88.8889ZM78 5.55556H58.5L52.9286 0H25.0714L19.5 5.55556H0V16.6667H78V5.55556Z" fill="#000" />
                      </svg>
                    </div>
                  </a>
                </div>
              </td>
            </tr>
          </template>
        </ui-table>
        
        <!--Modal Docs-->
        <ui-modal v-if="record != null" name="docs" type="email" >
          <template v-if="record == null" #content>
            <h4>Something went wrong :C</h4>
          </template>
          <template v-else #content>
            <div class="wrap-head">
                <div class="row">
                  <div class="col wrap-title">
                    <h4 class="title-g">
                      Generate Doc
                    </h4>
                    <span><strong>PK: </strong>{{record.item.PK}}</span><br>
                    <span><strong>SK: </strong>{{record.item.SK}}</span>
                  </div>
                  <div class="col wrap-button">
                    <ui-button style="margin: 0 0 0 10px;" :color="'red'" :text="'Cancel'" :position="'right'" data-dismiss="modal"/>
                  </div>
                </div>
              </div>
              <br>
              <div class="wrap-content row">
                <div class="col-md-3">
                  <h6>Select Template</h6>
                  <div class="smart-wrap">
                    <div class="input-wrap">
                      <label for="">Search Template</label>
                      <input type="text" id="search-docTemp" v-on:keyup="searchList('search-docTemp', 'docTemp' )">
                    </div>
                  </div>
                  <div class="list-group" id="docTemp">
                    <a style="cursor:pointer;" class="list-group-item list-group-item-action" v-for="(tmp, index) in docsTmp.templates" :key="index" v-on:click="docsGenerate('set', contact, tmp); docsTmp.tmp = tmp; "> 
                      {{tmp.templateName}}
                    </a>
                  </div>
                </div>
                <div class="col-md-9">
                  <form class="smart-wrap col-12" v-if="docsTmp.data" >
                    <div class="input-wrap col-12" v-for="(att, index) in docsTmp.data.attributes" :key="index">
                      <label for="">{{index}}</label>
                      <paper-displayer v-if="index == 'JSONContent'" :value="formatData('JSON',att)" style="width:100%; float: left;" />
                      <input v-else type="text" v-model="docsTmp.data.attributes[index]">
                    </div>
                    <div class="input-wrap html col-12">
                      <ui-button color="blue" text="Generate Adobe" style=" width:200px; padding: 10px 40px; margin:0 10px 0 0;" v-on:click="docsGenerate('generateAdobe', contact, docsTmp.tmp, docsTmp.data.attributes);" />
                      <ui-button color="green" text="Generate" style=" width:200px; padding: 10px 40px; margin:0 10px 0 0;" v-on:click="docsGenerate('generate', contact, docsTmp.tmp, docsTmp.data.attributes);" />
                    </div>
                    <div class="input-wrap html col-12">
                      <div id="textEditor-docs"></div>
                    </div>
                  </form>
                </div>
              </div>
          </template>
        </ui-modal>
        <!--Modal Sms-->
        <!--Modal Active-->
        <ui-modal name="active" type="status" classModal="modal-dialog-centered" >
          <template v-if="record == null" #content>
            <h4>{{record}}</h4>
          </template>
          <template v-else #content>
            <div class="row">
              <div class="col wrap-title">
                <h5 class="title-g" style="padding:15px 0 0 0;">
                  Delete item {{ record.item.entityName + " - " + record.item.friendlyId }} ?
                </h5>
              </div>
              <div class="col wrap-button">
                <ui-button style="margin: 0 0 0 10px;" :color="'red'" :text="'Cancel'" :position="'right'" data-dismiss="modal" />
                <ui-button v-if="record.item.active == '1'" style="margin: 0 0 0 10px;" :color="'green'" :text="'Confirm'" :position="'right'" data-dismiss="modal" v-on:click="setStatus(record.item.PK, record.item.SK, 'desactive')"/>
                <ui-button v-if="record.item.active == '0'" style="margin: 0 0 0 10px;" :color="'green'" :text="'Confirm'" :position="'right'" data-dismiss="modal" v-on:click="setStatus(record.item.PK, record.item.SK, 'active')"/>
              </div>
            </div>
          </template>
        </ui-modal>
        <!--Modal Archive-->
        <ui-modal name="archive" type="status" classModal="modal-dialog-centered" >
          <template v-if="record == null" #content>
            <h4>Something went wrong :C</h4>
          </template>
          <template v-else #content>
            <div class="row">
              <div class="col wrap-title">
                <h5 class="title-g" style="padding:15px 0 0 0;">
                  Archive item {{ record.item.entityName + " - " + record.item.friendlyId }} ?
                </h5>
              </div>
              <div class="col wrap-button">
                <ui-button style="margin: 0 0 0 10px;" :color="'red'" :text="'Cancel'" :position="'right'" data-dismiss="modal"/>
                <ui-button style="margin: 0 0 0 10px;" :color="'green'" :text="'Confirm'" :position="'right'" data-dismiss="modal"  v-on:click="setStatus(record.item.PK, record.item.SK, 'archive')"/>
              </div>
            </div>
          </template>
        </ui-modal>
      </div>
    </div>
  </div>
  <div  class="paper-dash" v-else-if="$router.currentRoute.value.query.name == 'client'">
    <paper-client />
  </div>
  <div v-else-if=" $router.currentRoute.value.query.name == 'SMLUP' " >
    <paper-smart />
  </div>
  <div v-else-if=" $router.currentRoute.value.query.name == 'edit'" >
    <paper-record />
  </div>
  <div v-else-if=" $router.currentRoute.value.query.name == 'posts' "  >
    <button class="btn-g gray show " v-on:click="getPosts()">refresh</button>
    <h1>POSTS</h1>
      <input type="checkbox" name="" id="" :value="true" v-model="showVersions">
    <div v-if="graphicPost != undefined && this.showVersions == true">
      <ui-button :text="'clear'" v-on:click="saveVersions('clear')" :position="'left'"/>
      <ui-button :text="'save'" v-on:click="saveVersions()" :position="'left'" :color="'green'"/>
      <br><br>
      <div  v-for="(grup, index) in graphicPost" :key="index" class="shadowBox" style="max-width: 1000px; display:block; background: #fff; border-radius: 10px ; overflow: hidden; position: relative;">
        <div style="padding: 20px;">
          <img  :src="grup.header.logo" alt="" style="width: 50px; float:left; margin: 0 20px 0 0;">
          <p style="float:left; margin: 12px 0;" > <strong>{{grup.header.date}}</strong> </p>
          <p style="clear:both; margin: 60px 0 0 0 ;">{{grup.header.subject}}</p>
        </div>
        <paper-constructor 
          :listDrop="post.layout" :palette="grup.palette" :idioms="['en']" :language="'en'"
          :styleDragg="'padding: 20px 0; margin: 40px 0; border:none; overflow:hidden;'" 
          
          v-for="(post, vindex) in grup.versions"  :key="vindex" 
        />
      </div>
    </div>
    <!--div v-if="graphicPost != undefined" v-for="(post, index) in graphicPost" :key="index" class="shadowBox" style="max-width: 1000px; margin: 40px auto; display:block; background: #fff; border-radius: 10px ; overflow: hidden;"  >
      :palette="record.palette" :idioms="record.idioms" :language="customPanel.language"
      <div style="padding: 20px;">
        <img  :src="post.header.logo" alt="" style="width: 50px; float:left; margin: 0 20px 0 0;">
        <p style="float:left; margin: 12px 0;" > <strong>{{post.header.date}}</strong> </p>
        <p style="clear:both; margin: 60px 0 0 0 ;">{{post.header.subject}}</p>
        <br>
      </div>
      <paper-layout :layout="JSON.parse(post.post)" :models="[]" />
      <paper-constructor :listDrop="JSON.parse(post.post)" :styleDragg="setStyleWrap(element)" />
    </div-->
    
    <paper-displayer :value="customItem"/>
    <ui-modal name="custom" type="custom"  >
      <template v-if="customItem != null" #content>
        <div class="panel smart-wrap">
          <div class="element-wrap col-md-12" style="margin:0;">
            <h4>{{customItem.attributeName}}</h4>
            <p>{{customItem.id}}</p>
          </div>
          <div class="input-wrap col-md-2" style="margin:0;">
            <label for="">Version</label>
            <input type="number" v-model="customItem.version" >
          </div>
          <div class="input-wrap col-md-8" style="margin:0;">
            <label for="">Attribute Name</label>
            <input type="text" v-model="customItem.attributeName" >
          </div>
          <div class="input-wrap col-md-2 " style="margin:0;">
            <div class="check-wrap">
              <label for="">Print</label>
              <div class="envelop">
                <input type="checkbox" name="" id="" v-model="customItem.print">
              </div>
            </div>
          </div>
          <div class="input-wrap col-md-12" style="margin:0;">
            <label for="">ID</label>
            <input type="text" v-model="customItem.id" >
          </div>
          <!-- Styles -->
          <div class="elemet-wrap row col-md-12"  style="background: #ffbc003d; margin:10px 0;">
            <h6 class="col-md-12" style=" padding: 10px"> Styles </h6>
            <div class="input-wrap col-md-12"> 
              <label > Class </label>
              <input type="text" v-model="customItem.class">
            </div> 
            <div class="customPanelOption col-md-12"> 
              <a class="drop" data-toggle="collapse" href="#collapse-style" role="button" aria-expanded="false" aria-controls="collapse-style">
                Styles 
                <svg style="float: right; margin: 0 10px 0 0;" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" width="1em" height="1em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 32 32"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M30 12L16 24L2 12"/></svg>
              </a>
              <div class="collapse" id="collapse-style">
                <div class="smart-wrap" style="border-bottom: 1px solid #ccc;">
                  <div class="input-wrap col-3"> 
                    <label > Width </label>
                    <input type="text" name="" id="" v-model="customItem.style.width[0]" >
                  </div> 
                  <div class="input-wrap col-3"> 
                    <label > Laptop(992px) </label>
                    <input type="text" name="" id="" v-model="customItem.style.width[1]" >
                  </div> 
                  <div class="input-wrap col-3"> 
                    <label > Tablet (767px) </label>
                    <input type="text" name="" id="" v-model="customItem.style.width[2]" >
                  </div> 
                  <div class="input-wrap col-3"> 
                    <label > Phone (520px) </label>
                    <input type="text" name="" id="" v-model="customItem.style.width[3]" >
                  </div> 
                  <div class="input-wrap col-3"> 
                    <label > Width Comp </label>
                    <input type="text" name="" id="" v-model="customItem.style.widthC[0]" >
                  </div> 
                  <div class="input-wrap col-3"> 
                    <label > Laptop(992px) </label>
                    <input type="text" name="" id="" v-model="customItem.style.widthC[1]" >
                  </div> 
                  <div class="input-wrap col-3"> 
                    <label > Tablet (767px) </label>
                    <input type="text" name="" id="" v-model="customItem.style.widthC[2]" >
                  </div> 
                  <div class="input-wrap col-3"> 
                    <label > Phone (520px) </label>
                    <input type="text" name="" id="" v-model="customItem.style.widthC[3]" >
                  </div> 
                  <div class="input-wrap col-3"> 
                    <label > Height </label>
                    <input type="text" name="" id="" v-model="customItem.style.height[0]">
                  </div>  
                  <div class="input-wrap col-3"> 
                    <label > 992 </label>
                    <input type="text" name="" id="" v-model="customItem.style.height[1]" >
                  </div> 
                  <div class="input-wrap col-3"> 
                    <label > 767 </label>
                    <input type="text" name="" id="" v-model="customItem.style.height[2]" >
                  </div> 
                  <div class="input-wrap col-3"> 
                    <label > 520 </label>
                    <input type="text" name="" id="" v-model="customItem.style.height[3]" >
                  </div> 
                  <div class="input-wrap col-3"> 
                    <label > Height </label>
                    <input type="text" name="" id="" v-model="customItem.style.heightC[0]">
                  </div>  
                  <div class="input-wrap col-3"> 
                    <label > 992 </label>
                    <input type="text" name="" id="" v-model="customItem.style.heightC[1]" >
                  </div> 
                  <div class="input-wrap col-3"> 
                    <label > 767 </label>
                    <input type="text" name="" id="" v-model="customItem.style.heightC[2]" >
                  </div> 
                  <div class="input-wrap col-3"> 
                    <label > 520 </label>
                    <input type="text" name="" id="" v-model="customItem.style.heightC[3]" >
                  </div> 
                  <div class="input-wrap col-6"> 
                    <label > transform </label>
                    <input type="number" name="" id="" v-model="customItem.style.transform">
                  </div> 
                </div>
                <div class="smart-wrap" style="border-bottom: 1px solid #ccc;">
                  <div class="input-wrap col-6"> 
                    <label > Padding </label>
                    <input type="text" name="" id="" v-model="customItem.style.padding">
                  </div> 
                  <div class="input-wrap col-6"> 
                    <label > Margin </label>
                    <input type="text" name="" id="" v-model="customItem.style.margin">
                  </div> 
                </div>
                <div class="smart-wrap" style="border-bottom: 1px solid #ccc;">
                  
                  
                  <div class="input-wrap col-2"> 
                    <label > Size </label>
                    <input type="text" name="" id="" min="5" v-model="customItem.style.font.size[0]" >
                  </div> 
                  <div class="input-wrap col-2"> 
                    <label > 992 </label>
                    <input type="text" name="" id="" min="5" v-model="customItem.style.font.size[1]" >
                  </div> 
                  <div class="input-wrap col-2"> 
                    <label > 767 </label>
                    <input type="text" name="" id="" min="5" v-model="customItem.style.font.size[2]" >
                  </div> 
                  <div class="input-wrap col-2"> 
                    <label > 520 </label>
                    <input type="text" name="" id="" min="5" v-model="customItem.style.font.size[3]" >
                  </div> 
                  <div class="input-wrap col-3"> 
                    <label > Weight </label>
                    <input type="number" v-model="customItem.style.font.weight">
                  </div> 
                  <div class="input-wrap col-6"> 
                    <label >Color </label>
                    <input style="width: 40px; float:left;" type="color" v-model="customItem.style.font.color" >
                    <select name="" id="" style="width: calc( 100% - 40px ); float:left;" v-model="customItem.style.font.color">
                      <option :value="index" v-for="(color, index) in customPanel.palette" :key="index">{{color}}</option> 
                    </select>
                  </div> 
                </div>
                <div class="smart-wrap" style="border-bottom: 1px solid #ccc;">
                  <div class="input-wrap col-4"> 
                    <label > Back Ground </label>
                    <input style="width: 40px; float:left;" type="color" v-model="customItem.style.bgc">
                    <select name="" id="" style="width: calc( 100% - 40px ); float:left;" v-model="customItem.style.bgc">
                      <option :value="index" v-for="(color, index) in customPanel.palette" :key="index">{{color}}</option> 
                    </select>
                  </div> 
                  <div class="input-wrap col-4" style="padding: 5px 0;"> 
                    <label > Border Color </label>
                    <input style="width: 40px; float:left;" type="color" v-model="customItem.style.border.color" >
                    <select name="" id="" style="width: calc( 100% - 40px ); float:left;" v-model="customItem.style.border.color">
                      <option :value="index" v-for="(color, index) in customPanel.palette" :key="index">{{color}}</option> 
                    </select>
                  </div> 
                  <div class="input-wrap col-2" style="padding: 5px 0;" > 
                    <label > Weight </label>
                    <input type="text" v-model="customItem.style.border.weight">
                  </div> 
                  <div class="input-wrap col-2" style="padding: 5px 0;"> 
                    <label > Type </label>
                    <input type="text" v-model="customItem.style.border.type">
                  </div> 
                </div>
                <div class="input-wrap col-md-12"> 
                  <label > Style Wrap</label>
                  <textarea rows="3" v-model="customItem.styleWrap"></textarea>
                </div> 
                <div class="input-wrap col-md-12"> 
                  <label > Style Component</label>
                  <textarea rows="3" v-model="customItem.styleComponent"></textarea>
                </div> 
              </div>
            </div> 
          </div>

          <!-- Element -->
          <div v-if="customItem.metaType == 'metaElement' || customItem.metaType == 'metaModule'" class="elemet-wrap row col-md-12"  style="background: #B0F5013d; margin:10px 0;">
            <h6 class="col-md-12" style=" padding: 10px">Element </h6>
            {{customItem.elementType}}
            <div class="input-wrap col-md-12" v-if="customItem.elementType == 'smartButton'">
              <label > Type Button </label>
              <select name="" id="" v-model="customItem.buttonType">
                <option value="link">Front End</option>
                <option value="queryButton ">Query Button </option>
                <option value="mutationButton">Mutation Button</option>
                <option value="appointment">Appointment</option>
                <option value="quizAction">Quiz Action</option>
              </select>
            </div>
            <div class="input-wrap col-md-3"> 
              <div class="check-wrap">
                <label for="">Plays Inline</label>
                <div class="envelop">
                  <input type="checkbox" name="" id="" v-model="customItem.playsinline">
                </div>
              </div>
            </div>
            <div class="input-wrap col-md-3"> 
              <div class="check-wrap">
                <label for="">Autoplay</label>
                <div class="envelop">
                  <input type="checkbox" name="" id="" v-model="customItem.autoplay">
                </div>
              </div>
            </div>
            <div class="input-wrap col-md-3"> 
              <div class="check-wrap">
                <label for="">Muted</label>
                <div class="envelop">
                  <input type="checkbox" name="" id="" v-model="customItem.muted">
                </div>
              </div>
            </div>
            <div class="input-wrap col-md-3"> 
              <div class="check-wrap">
                <label for="">Loop</label>
                <div class="envelop">
                  <input type="checkbox" name="" id="" v-model="customItem.loop">
                </div>
              </div>
            </div>
            <div class="input-wrap col-md-10"> 
              <label > URL / Image</label>
              <input type="text" v-model="customItem.url"  />
            </div> 
            <div class="input-wrap col-md-2"> 
              <label > Target (Change) </label>
              <input type="text" v-model="customItem.target"  />
            </div>
            <div class="input-wrap col-md-12"> 
              <label >Query Parameters (GRAPHQL, Preload List, Button)</label>
              <textarea id="custom-metaJSON" rows="5" :value="JSON.stringify(customItem.metaJSON) " v-on:keyup="validationInputJSON('custom-metaJSON', 'metaJSON')"></textarea>
            </div> 
          </div>

          <!-- Input -->
          <div v-if="customItem.metaType == 'metaInput'" class="elemet-wrap row col-md-12"  style="background: #F5E0013d; margin:10px 0;">
            <h6 class="col-md-12" style=" padding: 10px"> Input </h6>
            <div  class="input-wrap col-md-6"> 
              <label > Input Type </label>
              <select v-model="customItem.inputType">
                <option value="Boolean" >Boolean</option>
                <option value="CheckBox" >CheckBox</option>
                <option value="cognitoGroups" >Cognito Groups</option>
                <option value="Color" >Color</option>
                <option value="Counter" >Counter</option>
                <option value="Currency" >Currency</option> 
                <option value="Date" >Date</option>
                <option value="Editor" >Editor (discontinued)</option>
                <option value="Email" >Email</option>
                <option value="File" >File</option>
                <option value="GRAPHQL" >GRAPHQL</option>
                <option value="HTML" >HTML</option>
                <option value="JSON" >JSON</option>
                <option value="Number" >Number</option>
                <option value="Phone" >Phone</option>
                <option value="preloadList" >Preloaded List</option>
                <option value="quote" >Quote</option>
                <option value="RadioButton" >RadioButton</option>
                <option value="Range" >Range</option>
                <option value="Select" >Select</option>
                <option value="Text" >Text</option>
                <option value="TextArea" >Text Area</option>
                <option value="ZipCode" >ZipCode</option>
              </select>
            </div> 
            <div class="input-wrap col-md-6"> 
              <label > Format Type </label>
              <select v-model="customItem.format">
                <option value="numeric">Numeric</option>
                <option value="string">String</option>
                <option value="currency">Currency</option>
              </select>
            </div>
            <div class="input-wrap col-md-12"> 
              <label > Input Label </label>
              <input type="text" v-model="customItem.label"  />
            </div> 
            <div class="input-wrap col-md-3"> 
              <div class="check-wrap">
                <label for="">Is Repeatable</label>
                <div class="envelop">
                  <input type="checkbox" name="" id="" v-model="customItem.isRepeatable">
                </div>
              </div>
            </div> 
            <div class="input-wrap col-md-3"> 
              <div class="check-wrap">
                <label for="">Read Only</label>
                <div class="envelop">
                  <input type="checkbox" name="" id="" v-model="customItem.readOnly">
                </div>
              </div>
            </div> 
            <div class="input-wrap col-md-3"> 
              <div class="check-wrap">
                <label for="">Client Input</label>
                <div class="envelop">
                  <input type="checkbox" name="" id="" v-model="customItem.smartInput">
                </div>
              </div>
            </div> 
            <div class="input-wrap col-md-3"> 
              <div class="check-wrap">
                <label for="">Is Required</label>
                <div class="envelop">
                  <input type="checkbox" name="" id="" v-model="customItem.required">
                </div>
              </div>
            </div> 
            <div  class="input-wrap col-md-12"> 
              <label > Input Additionl Description </label>
              <textarea rows="5" v-model="customItem.description"></textarea>
            </div> 
            <div class="input-wrap col-md-12"> 
              <label > Input Help </label>
              <textarea name="" id="" cols="30" rows="5" v-model="customItem.help"></textarea>
            </div>
            <div class="input-wrap col-md-12"> 
              <label for="">Options List (Select, Checks, Radio, etc)</label>\
              <textarea id="custom-valueOptions" rows="5" :value="JSON.stringify(customItem.valueOptions) " v-on:keyup="validationInputJSON('custom-valueOptions', 'valueOptions')"></textarea>
            </div>
            <div class="input-wrap col-md-12" > 
              <label > File Security Level </label>
              <select v-model="customItem.securityLevel">
                <option value="public">Public</option>
                <option value="protected">Protected</option>
                <option value="private">Private</option>
                <option value="open">None</option>
              </select>
            </div> 
            <div class="input-wrap col-md-12"> 
              <label >Query Parameters (GRAPHQL, Preload List)</label>
              <textarea id="custom-metaJSON" rows="5" :value="JSON.stringify(customItem.metaJSON) " v-on:keyup="validationInputJSON('custom-metaJSON', 'metaJSON')"></textarea>
            </div> 
          </div>

          <!-- Layout -->
          <div v-if="customItem.metaType == 'metaLayout'" class="elemet-wrap row col-md-12"  style="background: #00F5C93d; margin:10px 0;">
            <h6 class="col-md-12" style=" padding: 10px">Layout</h6>
            <div class="input-wrap col-md-3"> 
              <div class="check-wrap">
                <label for="">Binded-layout</label>
                <div class="envelop">
                  <input type="checkbox" name="" id="" v-model="customItem.web">
                </div>
              </div>
            </div> 
            <div class="input-wrap col-md-3"> 
              <div class="check-wrap">
                <label for="">Is Repeatable</label>
                <div class="envelop">
                  <input type="checkbox" name="" id="" v-model="customItem.isRepeatable">
                </div>
              </div>
            </div> 
            <div class="input-wrap col-md-3"> 
              <div class="check-wrap">
                <label for="">Client Input</label>
                <div class="envelop">
                  <input type="checkbox" name="" id="" v-model="customItem.smartInput">
                </div>
              </div>
            </div> 
            <div class="input-wrap col-md-12"> 
              <label > Layout Label </label>
              <input type="text" v-model="customItem.label"  />
            </div> 

            <div  class="input-wrap col-md-12"> 
              <label > Layout Additionl Description </label>
              <textarea rows="5" v-model="customItem.description"></textarea>
            </div> 
            <div class="input-wrap col-md-12"> 
              <label > Layout Help </label>
              <textarea name="" id="" cols="30" rows="5" v-model="customItem.help"></textarea>
            </div>
            <div class="input-wrap col-md-12"> 
              <label >Query Parameters (GRAPHQL, Preload List)</label>
              <textarea id="custom-metaJSON" rows="5" :value="JSON.stringify(customItem.metaJSON) " v-on:keyup="validationInputJSON('custom-metaJSON', 'metaJSON')"></textarea>
            </div> 
          </div>

          <!-- Perrmisson -->
          <div class="elemet-wrap row col-md-12"  style="background: #ffbc003d;">
            <h6 class="col-md-12" style=" padding: 10px"> Permissions </h6>
            <div class="input-wrap col-md-6"> 
              <label for=""> Groups Can Edit</label> <br>
              <div class="envelop" v-for="(check, zindex) in permissions" :key="zindex">
                <input type="checkbox" class="box" :value="check.value" v-model="customItem.groupsCanEdit"/>
                <span class="text" >&nbsp; {{check.value}} </span>
              </div>
            </div> 
            <div class="input-wrap col-md-6"> 
              <label for="">Groups Can Read</label><br>
              <div class="envelop" v-for="(check, zindex) in permissions" :key="zindex">
                <input type="checkbox" class="box" :value="check.value" v-model="customItem.groupsCanRead"/>
                <span class="text" >&nbsp; {{check.value}} </span>
              </div>
            </div> 
            <div class="input-wrap col-md-6"> 
              <label for="">User Can Edit</label>
              <br>
              <input type="checkbox" class="box" value="@author" v-model="customItem.usersCanEdit"/>
              <span class="text" >&nbsp; @Author </span>
              <br>
              <input type="checkbox" class="box" value="@client" v-model="customItem.usersCanEdit"/>
              <span class="text" >&nbsp; @Client </span>
              <br>
              <input type="checkbox" class="box" value="@responsible" v-model="customItem.usersCanEdit"/>
              <span class="text" >&nbsp; @Responsible </span>
            </div> 
            <div class="input-wrap col-md-6"> 
              <label for="">User Can Read</label>
              <br>
              <input type="checkbox" class="box" value="@author" v-model="customItem.usersCanRead"/>
              <span class="text" >&nbsp; @Author </span>
              <br>
              <input type="checkbox" class="box" value="@client" v-model="customItem.usersCanRead"/>
              <span class="text" >&nbsp; @Client </span>
              <br>
              <input type="checkbox" class="box" value="@responsible" v-model="customItem.usersCanRead"/>
              <span class="text" >&nbsp; @Responsible </span>
            </div> 
          </div>
          <paper-displayer :value="customItem"/>
        </div>
        <div class="action">
          <ui-button text="Apply"  style="width: calc(40% - 10px); float:left; margin:0 5px;" color="green" v-on:click="applyCustomItem([customItem,'edit'])" />
          <ui-button text="Clone"  style="width: calc(20% - 10px); float:left; margin:0 5px;" color="blue" v-on:click="applyCustomItem([customItem,'clone'])" >
          </ui-button>
          <ui-button text="Remove"  style="width: calc(20% - 10px); float:left; margin:0 5px;" color="red" v-on:click="applyCustomItem([customItem, 'delete'])" />
          <ui-button text="X" style="width: calc(20% - 10px); float:left; margin:0 5px;" data-dismiss="modal" />
        </div>
      </template>
    </ui-modal>
  </div>
  <div v-else-if=" $router.currentRoute.value.query.name == 'billing' "  >
    <paper-user>
    </paper-user>
  </div>
  <div class="paper-table" v-else>
    <paper-table ref="paperTable"/>
  </div>
</template>
<script>
//
let tokenQuote = null
//AWS - GRAPHQL
import { smd_getRecord2, smd_getRecordObj, smd_getDashDataYear,smd_getDashDataContact, smd_generateGraphicPost, smd_getSMLItem,smd_listEntityObj, smd_composeEmailTemplate, smd_getDocTemplatesList, smd_getDocTemplateAttributes,smd_generateDocTemplates } from '../graphql/queries'
import { smd_updateSmartRecord,smd_updateAttributes, smd_sendEmail2,smd_cloneSmartRecord, smd_addToFavorites, smd_setItemState, smd_createUserFromEmail,smd_sendSMS, smd_generateDocAdobeApi, smd_savePaymentFormContact } from '../graphql/mutations'
import { onUpdateSmartRecord } from '../graphql/subscriptions'
//Tools
import Vuex from 'vuex'
import { API } from 'aws-amplify'
import Swal from 'sweetalert2'
import { formatData, searchList,loading,popUp } from '../store/tools.js';
//import { v4 as uuidv4 } from 'uuid';
//Components
import PaperTableOld from './papers/PaperTableOld.vue'
import PaperUser from './papers/PaperUser.vue'
import PaperTable from './papers/PaperTable.vue'
import PaperTableView from './papers/PaperTableView.vue'
import PaperSmart from './papers/PaperSmart.vue'
import PaperHistory from './papers/PaperHistory.vue'
import PaperLayout from './papers/PaperLayout.vue'
import PaperDisplayer from './papers/PaperDisplayer.vue'
import PaperRecord from './papers/PaperRecord.vue'
import PaperConstructor from './papers/PaperConstructor.vue'
import PaperClient from './papers/PaperClient.vue'
import UiChartsV2 from './ui/UiChartsV2.vue'
import UiAccionButton from './ui/UiAccionButton.vue'
import UiModal from './ui/UiModal.vue'
import UiTable from './ui/UiTable.vue'
import PlEditor from '../assets/plugins/PlEditor.vue'
import trumbowyg  from 'trumbowyg'
import 'trumbowyg/dist/ui/trumbowyg.css';

//import $ from "jquery";Zx 


import UiButton from './ui/UiButton.vue'
//import html2pdf from 'html2pdf'
export default {
  name: "content",
  components:{
    UiTable,
    PaperTableOld,
    PaperSmart,
    PaperHistory,
    PaperTableView,
    UiButton,
    PaperLayout,
    PaperDisplayer,
    PaperRecord,
    UiChartsV2,
    PaperConstructor,
    UiAccionButton,
    UiModal,
    PaperClient,
    PaperTable,
    PlEditor,
    PaperUser
  },

  data() {
    return {
      docsTmp:{},
      emailTemplate:'',
      dataSMS:{},
      year:'',
      currency: '10',
      data: null, 
      layout:[],
      //data
      dataCharts: undefined,
      dataTable: undefined,


      graphicPost: undefined,
      months:['Jan','Feb','Mar','Apl','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'],
      dataGraph:[
        { value:20, text:'20%' },
        { percentage:40, text:'40%' },
        { percentage:10, text:'10%' },
        { percentage:30, text:'30%' },
        //{ percentage:10, text:'10%' },
      ],
      customPanel:{
        search:'',
        focusComponentType:'#MEL',
        componentList: [],
        language:'en',
        palette:['Main Color','Secondary  Color','Font Primary Color','Font Secondary Color','Acent Color','Black Color','White Color'],
        assets:[],
        PK:'#SMARTDASH',
      },
      mode:[true,true,true,true,true,true,true,true,true,true,true,true],
      showVersions: false,
      layoutFormats: {
        none: ' ',
        draft:'width: 1000px; height:1000px;', 
        twiterPost:'width: 1012px; height:506px;', 
        twiterHeader: 'width: 1500px; height:500px;', 
        facebookPost:'width: 1200px; height:630px;', 
        instagramPost :'width: 1080px; height:1080px;', 
        instagramStory:'width: 1000px; height:1920px;', 
        dribbbleShot:'width: 400px; height:300px;',
        linkedinCover:'width: 1584px; height:396px;',
      },

      //DATA
      record: null,
      contact: null,
      sub:false,
      //billing
      tandc:false,

      //Emails
      toEmail: null,
      subjectEmail: null,
      emailTemplates: null,
      dataEditor: null,

      //filterSmarForm
      filterSmarForm: 'all',
      layoutCategory: '',
      activeStatus: '1',
      filterEntity: 'all',

      
      focusEntity: 'ALL',
      v_search:'',
      
      //table
      tableEntities: [['all','ALL']],

      tableRecords: {
        entities: null,
        src:null,
        ram:null,
      },

      //
      pagination:{
        display:10, // n display
        position: 0, // n records
        index:0 // count index
      }
    }
  },
  created() {
    switch (this.$router.currentRoute.value.query.name) {
      case 'clietDash':
        let data = {PK: '#SMARTDASH', SK:'#SML#55994203-121c-4092-b8d6-36d90c65251a',GSP1PK1 :this.$router.currentRoute.value.query.data }
        this.getDashChartsClient(data)
        this.setPaymentMethods()
        console.log( this.modules);
      break;
      case 'posts':
        this.getPosts()
      break;
      default:
        this.getDashDataCharts()
      break;
    }
    this.subscribe()
  },
  methods: {
    //Vuex
    ...Vuex.mapMutations([
      "setDataUser",
      "setRecord",
      "setgRecord", // Record To edit
      "applyCustomItem",
    ]),
    ...Vuex.mapActions([
      "setFormat",
      "getRecord"
    ]),
    //Sub
    subscribe() { 
      API.graphql({ query: onUpdateSmartRecord }).subscribe({
        next: (eventData) => {
          try {
            let pullData = eventData.value.data.onUpdateSmartRecord;
            let data = JSON.parse(pullData.data)
            if (this.record.item.SK == data.SK && data.updatedBy != this.user) {
              this.sub = true
            }
            
          } catch (error) {
            
          }
          
        }
      });
    },
    //Tools
    searchList(input, list){
      searchList(input, list);
    },
    formatData(format, data){
      return formatData(format, data)
    },
    checkAttribute(data){
      return data
      if (!this.dataTable[0].hasOwnProperty(data.attributeName)) {
      }
    },
    loading(action, origin){
      if (action == 'show') {
        document.getElementById("loading").classList.add('show')
        document.getElementById("body").classList.add("noScroll")
      }else{
        document.getElementById("loading").classList.remove('show')
        document.getElementById("body").classList.remove("noScroll")
      }
    },
    async setEditor(SK){
      //console.clear()
      try {
        setTimeout(() => {
          $(`#editor${SK}`).trumbowyg({
            svgPath: false,
            hideButtonTexts: true
          });
          console.log( document.getElementById(`editor${SK}`));
          document.getElementById(`editor${SK}`).innerHTML = document.getElementById(`editor${SK}`).innerHTML + ''
        }, 100);
      } catch (error) {
        console.log(error);
      }
    },
    setDataEditor(component,index, td){
      try {
        setTimeout(() => {
          //this.models[component.attributeName].value = escape(document.getElementById(`editor${index}`).innerHTML)
        }, 100);
      } catch (error) {
        
      }
    },
    //Functions
    async setPaymentMethods(){
      let form = null
      //------
      let pullData = null
      let pushData = null
      let type = null
      try {
        pushData={
          PK: '#SMARTDASH',
          SK: "#ORG#SMARTDASH",
        }
        pullData = await API.graphql({
          query: smd_getRecordObj,
          variables: pushData
        })
        pullData = pullData.data.smd_getRecordObj
        pullData = JSON.parse(pullData.data)
        console.log(pullData);
        type = this.organizationData.paymentMode.toLowerCase() 
      } catch (error) {
        console.log(error);
        //popUp(error, 'cach', 'err')
      }
      //------
      setTimeout(() => {
        //console.clear()
        let authorization = null;
        form = document.getElementById('cardForm')
        if (type == 'production') {
          authorization = pullData.clientsideToken.value
        } else {
          authorization = pullData.sandboxClientsideToken.value;
        }
        braintree.client.create({ authorization: authorization }, 
        function (err, clientInstance) {
          if (err) {
            console.error(err);
            return;
          }
          createHostedFields(clientInstance);
        });
      }, 500);
      function createHostedFields(clientInstance) {
        braintree.hostedFields.create({
          client: clientInstance,
          styles: {
            'input': {
              'font-size': '16px',
              'font-family': 'courier, monospace',
              'font-weight': 'lighter',
              'color': '#555555'
            },
            ':focus': {
              'color': 'black'
            },
            '.valid': {
              'color': '#08a414f7'
            }
          },
          fields: {
            number: {
              selector: '#card-number',
              //placeholder: '4111 1111 1111 1111'
            },
            cvv: {
              selector: '#cvv',
              //placeholder: '123'
            },
            expirationDate: {
              selector: '#expiration-date',
              placeholder: 'MM/YYYY'
            },
            postalCode: {
              selector: '#postal-code',
              //placeholder: '11111'
            }
          }
        }, function (err, hostedFieldsInstance) {
          if (err) {
            console.error(err);
            return;
          }
          var tokenize = function (event) {
            event.preventDefault();
            hostedFieldsInstance.tokenize(function (err, payload) {
              if (err) {
                console.log(err);
                tokenQuote = JSON.stringify({token:null, processorResponse:err })
                Swal.fire({
                  icon: 'error',
                  title: 'Something went wrong!' ,
                  text: JSON.stringify(err.message),
                })
                return;
              }
              tokenQuote = JSON.stringify({token:payload.nonce, processorResponse:payload })
              //alert('Submit your nonce (' +  payload.nonce + ') to your server here!');
            });
          };
          
          form.addEventListener('submit', tokenize, false);
          //form.on("submit", tokenize, false);
        });
      }
    },
    async token(){
      let pullData = null
      try {
          if (JSON.parse(tokenQuote).token == null) {
            return
          }
          loading('show')
          let pushData =  {
            orgPK: this.organizationID ,// data.PK,
            paymentParameters: tokenQuote,
            contactSK: this.contact.SK,
          }
          pullData = await API.graphql({
            query : smd_savePaymentFormContact,
            variables:pushData
          })
          
          pullData = pullData.data.smd_savePaymentFormContact
          if (pullData.smd_response.statusCode != 200) {
            popUp(pullData.smd_response, 'response', 'err')
            loading('hide', 'getItem')
            return
          }
          $('.collapse').collapse('hide')
          this.getDashChartsClient({PK: '#SMARTDASH', SK:'#SML#55994203-121c-4092-b8d6-36d90c65251a',GSP1PK1: this.$router.currentRoute.value.query.data })
          console.log(pullData, tokenQuote);
          //this.getData()
          loading('hidden')
      } catch (error) {
        loading('hidden')
        console.log(error);
        popUp(error, 'cach', 'err')
        }
    },
    async action(){
      setTimeout(() => {
        this.token()
      }, 1000);
    },
    async docsGenerate(action, data, tmp, att){
      console.log(action+this.organizationID);
      let pullData = {}
      let config = {}
      switch (action) {
        case 'init':
          this.docsTmp = {}
          try {
            pullData = await API.graphql({
              query: smd_getDocTemplatesList,
              variables: {
                orgPK: this.organizationID ,
              },
            });
            pullData = pullData.data.smd_getDocTemplatesList
            pullData = JSON.parse(pullData.data)
            
            for (let index = 0; index < pullData.length; index++) {
              const element = pullData[index];
              for (let vindex = 0; vindex < element.attributes.length; vindex++) {
                const velement = element.attributes[vindex];
                pullData[index][velement.attributeName] =velement.attributeValue
              }
            }
            console.log(pullData);
            this.docsTmp.templates = pullData
          } catch (error) {
            console.log(error);
            Swal.fire({
              icon: 'error',
              title: 'Something went wrong!' ,
              text: JSON.stringify(error),
            })
          }
        break;
        case 'set':
          try {
            config={
              orgPK: this.organizationID,
              GSP1PK1: data.SK,
              templateSK:tmp.SK,
            },
            //console.log(config);
            pullData = await API.graphql({
              query: smd_getDocTemplateAttributes,
              variables: config
            });
            pullData = pullData.data.smd_getDocTemplateAttributes
            //console.log(pullData);
            pullData = JSON.parse(pullData.data)
            this.docsTmp.data = pullData
            setTimeout(() => {
              $(`#textEditor-docs`).trumbowyg({
                svgPath: false,
                hideButtonTexts: true
              });
              
            }, 200);
          } catch (error) {
            console.log(error);
            Swal.fire({
              icon: 'error',
              title: 'Something went wrong!' ,
              text: JSON.stringify(error),
            })
          }
        break;
        case 'generateAdobe':
          try {
            config={
              orgPK: this.organizationID,
              GSP1PK1: data.SK,
              templateSK:tmp.SK,
              attributes: JSON.stringify(att),
              inputJSON: att.JSONContent
            },
            console.log(config);
            pullData = await API.graphql({
              query: smd_generateDocAdobeApi,
              variables: config
            });
            console.log(pullData);
            pullData = pullData.data.smd_generateDocAdobeApi
            this.docsTmp.data.body = pullData.data
            console.log(pullData.data);
            document.getElementById(`textEditor-docs`).innerHTML = this.docsTmp.data.body
          } catch (error) {
            console.log(error);
            Swal.fire({
              icon: 'error',
              title: 'Something went wrong!' ,
              text: JSON.stringify(error),
            })
          }
        break;
        case 'generate':
          try {
            config={
              orgPK: this.organizationID,
              GSP1PK1: data.SK,
              templateSK:tmp.SK,
              attributes: JSON.stringify(att)
            },
            //console.log(config);
            pullData = await API.graphql({
              query: smd_generateDocTemplates,
              variables: config
            });
            pullData = pullData.data.smd_generateDocTemplates
            this.docsTmp.data.body = pullData.data
            console.log(pullData.data);
            document.getElementById(`textEditor-docs`).innerHTML = this.docsTmp.data.body
          } catch (error) {
            console.log(error);
            Swal.fire({
              icon: 'error',
              title: 'Something went wrong!' ,
              text: JSON.stringify(error),
            })
          }
        break;
      }
    },
    setDataEditor2(id, data, action){
      switch (action) {
        case 'init':
          setTimeout(() => {
            document.getElementById(id).innerHTML = data
          }, 100);
        break;
        case 'edit':
          setTimeout(() => {
            this.emailTemplate = document.getElementById(id).innerHTML 
          }, 100);
        break;
      }
    },
    async f_emailTemplates(action, PK, SK, item){
      console.log(action);
      switch (action) {
        case 'list':
          try {
            this.toEmail = ""
            this.subjectEmail=""
            const wo_PullItem = await API.graphql({
              query: smd_listEntityObj,
              variables: {
                active: '1' ,
                PK: this.organizationID,
                shortEntity: 'EMT',
                pageSize: 0 ,
              },
            });
            console.log(JSON.parse(wo_PullItem.data.smd_listEntityObj.data));
            this.emailTemplates = JSON.parse(wo_PullItem.data.smd_listEntityObj.data)
          } catch (error) {
            console.log(error);
          }
        break;
        case 'set':
          try {              
            console.clear()
            console.log(this.organizationID +'-'+ SK);
            let pullData = await API.graphql({
              query: smd_composeEmailTemplate,
              variables: {
                emailTPK: this.organizationID,
                emailTSK: SK,
                itemPK: this.organizationID,
                itemSK: this.record.item.SK,
                itemGSP1PK1: this.record.item.GSP1PK1,
                itemGSP1SK1: this.record.item.GSP1SK1,
                baseURL: window.location.origin, 
              },
            });
            pullData = pullData.data.smd_composeEmailTemplate
            console.log(pullData);
            this.toEmail = ''
            this.toEmail = JSON.parse(pullData.data).emails
            this.subjectEmail = JSON.parse(pullData.data).subject
            this.emailTemplate = JSON.parse(pullData.data).body
            console.log(document.getElementById('visual-editor-modal-email'));
            //document.getElementById('visual-editor-modal-email').innerHTML =  this.emailTemplate
            //this.inputHtml('emailTemplate', this.emailTemplate )
          } catch (error) {
            console.log(error);
          }
        break;
        case 'send':
          try {              
            let push = ''
            console.log(this.emailTemplate);
            push = await API.graphql({
              query: smd_sendEmail2, //smd_updateSmartRecord
              variables: {
                to: this.toEmail,
                subject: this.subjectEmail,
                bodyHTML: this.emailTemplate
              },
            });
            console.log('eviado exitosament');
            console.log(push);
            //smd_sendEmail2(bodyHTML: "hello hello", to: "marcelo@bizplaneasy.comm", subject: "hola from lambda")
            Swal.fire({
              icon: 'success',
              title: 'Mail sent successfully' ,
              //text: JSON.stringify(error),
            })
          } catch (error) {
            console.log(error);
            Swal.fire({
              icon: 'error',
              title: 'error' ,
              text: JSON.stringify(error),
            })
          }
        break;
        case 'editor':
          try {       
            this.itemPK = PK
            this.itemSK = SK
            setTimeout(() => {      
              this.setEditor(SK)
            }, 1000);
          } catch (error) {
            console.log(error);
          }
        break;
        case 'editorQuote':
          try {       
            this.f_emailTemplates('list')
            
            try {
              
            } catch (error) {
              
            }
          } catch (error) {
            console.log(error);
          }             
        break;
      }
    },
    async msmActions(action, data){
      console.clear()
      console.log(action);
      switch (action) {
        case 'init':
          console.log(data);
          this.dataSMS.options = []
          this.dataSMS.message = ''
          this.dataSMS.PK = data.PK
          switch (data.shortEntity) {
            case "CON":
              this.dataSMS.options = data.SMLPhones
            break;
            case "PHO":
              this.dataSMS.phone = data.SK
            break;
            case "PHC":
              this.dataSMS.phone = 'PHO#'+data.phoneNumber
            break;
          }
        break;
        case 'send':
          let push = ''
          let config = {}
          try {     
            
            config={
              phonePK: data.PK,
              phoneSK: data.phone,
              message: data.message
            }
            console.log(config);
            push = await API.graphql({
              query: smd_sendSMS, //smd_updateSmartRecord
              variables: config
            });
            console.log('eviado exitosament');
            console.log(push);
            //smd_sendEmail2(bodyHTML: "hello hello", to: "marcelo@bizplaneasy.comm", subject: "hola from lambda")
            Swal.fire({
              icon: 'success',
              title: 'SMS sent successfully' ,
              //text: JSON.stringify(error),
            })
          } catch (error) {
            console.log(error);
            Swal.fire({
              icon: 'error',
              title: 'error' ,
              text: JSON.stringify(error),
            })
          }
        break;
      }
    },
    setCurrency( input ){
      let value = document.getElementById(input).value
      //Validation
      if (value.test()) {
        
      }
      console.log(value);
    },
    async buttonsView(action){
      try {
        let buttonSave = await document.getElementById('save-'+this.record.item.SK)
        let buttonSaveClose = await document.getElementById('saveClose-'+this.record.item.SK)
        if (action == 'show') {
          buttonSave.classList.add('show')
          buttonSaveClose.classList.add('show')
        }else{
          buttonSave.classList.remove('show')
          buttonSaveClose.classList.remove('show')
        }
      } catch (error) {
        //console.log(error);
      }
    },
    async getPosts(){
      let pullData = ''
      try {
        pullData = await API.graphql({
          query: smd_generateGraphicPost,
          variables:{
            itemPK:this.organizationID,
            itemSK:this.$router.currentRoute.value.query.data,
          }
        })
        pullData = pullData.data.smd_generateGraphicPost
        console.log(pullData);
        this.graphicPost =JSON.parse(pullData.data)
        for (let index = 0; index < this.graphicPost.length; index++) {
          const element = this.graphicPost[index];
          this.graphicPost[index].palette = JSON.parse(element.palette)
          for (let zindex = 0; zindex < element.versions.length; zindex++) {
            const version = element.versions[zindex];
            console.log(version);
            this.graphicPost[index].versions[zindex].layout = JSON.parse(version.layout)
          }
        }
        this.showVersions = true 
      } catch (error) {
        console.log(error);
      }
    },
    async getDashLayout( data){
      let pullData = ''
      try {
        pullData = await API.graphql({
          query: smd_getRecord2,
          variables: {
            PK: data.PK,
            SK: data.SK,
          },
        });
        pullData = pullData.data.smd_getRecord2
        console.log(pullData);
        //console.log("--> Data of Query LAYOUT :", wo_PullItem.data.smd_getRecord.strAtt );
        //console.log("--> Data of Query LAYOUT :", JSON.parse(wo_PullItem.data.smd_getRecord.strAtt)[0]['smartlayout.Layout'] );
        //this.layout = JSON.parse(pullData.strAtt)[0]['smartlayout.Layout']
      } catch (error) {
        
        console.log(error);
      }
    },
    async getDashChartsClient( data){ 
      console.clear()
      this.loading('show','getDashChartsClient')
      let pullData = ''
      let dataTable = []
      // Local contact
      let contact ={
        phones:[],
        emails:[],
      }
      this.contact = null
      try {
        pullData = await API.graphql({
          query: smd_getDashDataContact,
          variables: {
            ORGPK: this.organizationID,
            GSP1PK1: data.GSP1PK1,
            active: this.activeStatus
          },
        }); 
        pullData = pullData.data.smd_getDashDataContact
        this.dataCharts = JSON.parse(pullData.data)
        pullData = JSON.parse(pullData.additionalData)
        //clear variables
        this.tableRecords= null
        let tableRecords= {
          src:{ALL:[]},
          entities:{ALL:'ALL'},
          ram:null,
        }

        //console.log('pullData proceced:', pullData);
        
        for (let index = 0; index < pullData.length; index++) {
          let record = pullData[index];
          try {
            //Check if exist entitie
            if (!tableRecords.src[record.entityName]) {
              tableRecords.src[record.entityName] = []
              tableRecords.entities[record.entityName] = record.shortEntity
            }
            // pending check
            for (const key in record.attributes) {
              try {
                if (record.attributes[key].attributeType == 'L') {
                  let value = JSON.parse(record.attributes[key].value)
                  let tmpValue = ''
                  for (const att in value) {
                    if (att != 'PK' && att != 'SK' ) {
                      tmpValue = tmpValue + ' ' + value[att]
                    }
                  }
                  pullData[index][key] = tmpValue
                }else{
                  pullData[index][key] = record.attributes[key].value
                }
              } catch (error) {
                console.log(error);
              } 
            }

            if (record.shortEntity == 'CON') {
              this.contact = record
              console.log(this.contact);
              document.getElementById('title').innerText = record['contact.firstName']+' '+ record['contact.lastName']
              //this.dataTable.splice(index, 1)
            }
            if (record.shortEntity == 'PHO') {
              contact.phones.push(JSON.parse(JSON.stringify(record)))
            }
            if (record.shortEntity == 'EML') {
              contact.emails.push(record)
            }
            tableRecords.src[record.entityName].push(record)
            tableRecords.src.ALL.push(record)
          } catch (error) {
            console.log( tableRecords.src, record.entityName);
            console.log(error);
          }
        }
        //asign global vars
        this.contact = { ...this.contact, ...contact }
        tableRecords.ram =  Array.from(tableRecords.src[this.focusEntity])
        this.tableRecords = {...tableRecords}
        console.log('tableRecords:',tableRecords);

      } catch (error){
        console.log(error);
      }
      this.loading('hidden','getDashChartsClient')
    },
    async getDashDataCharts( ){
      try {
        let pullData = await API.graphql({
          query: smd_getDashDataYear,
          variables: {
            orgPK: this.organizationID,
            year: this.year,
          },
        });
        pullData = pullData.data.smd_getDashDataYear
        console.log("--> Data of smd_getDashDataYear:", pullData  );
        this.dataCharts = JSON.parse(pullData.data)
        console.log("--> Data of smd_getDashDataYear:", this.dataCharts  );
        //console.log("--> Data of Query LAYOUT :", JSON.parse(wo_PullItem.data.smd_getRecord.strAtt)[0]['smartlayout.Layout'] );
        //this.layout = JSON.parse(wo_PullItem.data.smd_getRecord.strAtt)[0]['smartlayout.Layout']
      } catch (error) {
        console.log(error);
      }
    },
    async saveVersions(action){
      this.showVersions = false 
      console.log('HOLA');
      let push = ''
      let layout = ''
      if (action == 'clear') {
        try {
          layout = [{
          attributeName: 'savedLayouts',
          attributeValue: '',
          attributeType: 'L',
        }]
          push = await API.graphql({
            query: smd_updateAttributes, //smd_updateSmartRecord
            variables: { 
              PK: this.organizationID,
              SK: this.$router.currentRoute.value.query.data ,
              attributes: JSON.stringify(layout) ,
            },
          });
          console.log("Creado exitosamente");
          push = push.data.smd_updateAttributes
          console.log(push);
        } catch (error) {
          console.log(error);
        }
      } else {
        for (let index = 0; index < this.graphicPost.length; index++) {
          const element = this.graphicPost[index];
          this.graphicPost[index].palette = JSON.stringify(element.palette)
          for (let zindex = 0; zindex < element.versions.length; zindex++) {
            const version = element.versions[zindex];
            console.log(version);
            this.graphicPost[index].versions[zindex].layout = JSON.stringify(version.layout)
          }
        }
        layout = [{
          attributeName: 'savedLayouts',
          attributeValue: JSON.stringify(this.graphicPost),
          attributeType: 'L',
        }]
        try {
          push = await API.graphql({
            query: smd_updateAttributes, //smd_updateSmartRecord
            variables: { 
              PK: this.organizationID,
              SK: this.$router.currentRoute.value.query.data ,
              attributes: JSON.stringify(layout) ,
            },
          });
          console.log("Creado exitosamente");
          push = push.data.smd_updateAttributes
          console.log(push);
        } catch (error) {
          console.log(error);
        }
        for (let index = 0; index < this.graphicPost.length; index++) {
          const element = this.graphicPost[index];
          this.graphicPost[index].palette = JSON.parse(element.palette)
          for (let zindex = 0; zindex < element.versions.length; zindex++) {
            const version = element.versions[zindex];
            console.log(version);
            this.graphicPost[index].versions[zindex].layout = JSON.parse(version.layout)
          }
        }
        console.log({
          PK: this.organizationID,
          SK: this.$router.currentRoute.value.query.data ,
          attributes: JSON.stringify(layout) ,
        });
      }
      this.showVersions = true 
    },
    //Table
    setDataTable(){
      this.tableRecords.ram = Array.from(this.tableRecords.src[this.focusEntity]);
      this.pagination.index = index;
      this.pagination.position = (this.pagination.index* this.pagination.display);
    },
    async getItem( data, mode, indexAction  ) { 
      //console.clear()
      this.record = null
      this.sub= false
      this.loading('show', 'getItem')
      let pullData = null
      let action = null
      let entity = null
      console.log('>> Data Item: ',data);
      console.log('>> Mode: ',mode);
      try {
        let query = {
          itemPK: data.PK,
          itemSK: data.SK,
          SMLPK: data.form.PK,
          SMLSK: data.form.SK,
          parent: data.parent,
          entity: data.entity
        }
        switch (mode) {
          case 'action':
            action = JSON.parse(this.entities[data.shortEntity]['SML.descendantEntitiesWithForm'])[indexAction]
            //console.log('This action for item:',action);
            query.SMLPK = action['modules.formSK'].PK
            query.SMLSK = action['modules.formSK'].SK
            query.entity = {
              PK: action['metaEntity.descendantEntities'].PK ,
              SK: action['metaEntity.descendantEntities'].SK 
            },
            query.parent = {
              PK: data.PK ,
              SK: data.SK,
            }
            query.itemPK= undefined
            query.itemSK= undefined
            //Check entity for record
            for (const key in this.entities) {
              if ( action['metaEntity.descendantEntities'].value == this.entities[key]['metaEntity.name']) {
                entity = this.entities[key]
              }
            }
          break;
          case 'status':
            console.log(data);
            this.record ={}
            this.record.item = data
            this.loading('hidde', 'getItem || set Status')
            return
          break;
          case 'email':
            console.log(data);
            this.record ={}
            this.record.item = data
            this.loading('hidde', 'getItem || set email')
            return
          break;
          case 'out':
            console.log(data);
            this.record ={}
            this.record.item = data
            this.loading('hidde', 'getItem || set out')
            return
          break;
        } 
        console.log(query);
        pullData = await API.graphql({
          query: smd_getSMLItem,
          variables: query
        });
        
        pullData = pullData.data.smd_getSMLItem
        console.log("--> Data of Query Before :", pullData);

        //Proccess Data
        pullData.layout =  JSON.parse(pullData.data)
        pullData.item =  JSON.parse(pullData.item)
        if (mode == 'action') {
          console.log(entity);
          pullData.item.shortEntity = entity['metaEntity.metaShortEntity']
          pullData.item.entity = query.entity
          pullData.item.entityName = entity['metaEntity.name']
          pullData.item.parent = {
            PK: data.PK,
            SK: data.SK,
          }
          pullData.item.form = {
            PK:  query.SMLPK,
            SK:  query.SMLSK,
          }
        }
        
        console.log(pullData.item.attributes)
        
        if (pullData.item.shortEntity == 'INF') {
          for (const key in pullData.item.attributes) {
            if (!pullData.item.attributes[key].hasOwnProperty('complete')) {
              pullData.item.attributes[key].complete = false
            }
          }
        }
        pullData.attStr =  JSON.stringify(pullData.item.attributes)
        console.log("--> Data of Query After :", pullData);
        delete pullData.data
        this.record = pullData
        this.setRecord(pullData)
      } catch (error) {
        console.log(error);
      }
      this.sub= false
      this.loading('hidde', 'getItem')
    },
    async updateRecord(data, mode) {  
      console.clear();
      this.loading('show', 'updateRecord')
      console.log('>> Data Item: ',data);
      //console.log('>> Mode: ',mode);
      let query = { }
      let pushData = ''
      try {
        //Set Mode and Config
        //asconsole.log(JSON.stringify(processBinds('push',data.item.attributes )));
        query = {
          shortEntity: data.item.shortEntity,
          PK: data.item.PK,
          SK:  data.item.SK,
          attributesStr: JSON.stringify(data.item.attributes) ,
          entity: data.item.entity,
          form: data.item.form,
          parent:  data.item.parent,
          usersCanEdit: data.item.usersCanEdit,
          usersCanRead: data.item.usersCanRead ,
          groupsCanEdit: data.item.groupsCanEdit,
          groupsCanRead: data.item.groupsCanRead,
        }
        
        if (query.SK == '') {
          query.SK = undefined
          query.PK = this.organizationID
        }
        console.log(' >> Push Data <<\n', query);
        //Mutation
        pushData = await API.graphql({
          query: smd_updateSmartRecord, //smd_updateSmartRecord
          variables: { 
            input:query
          },
        });
        pushData = pushData.data.smd_updateSmartRecord
        console.log(' >> Successful update <<' ,pushData);
        pushData = JSON.parse(pushData.data)
        this.record.item = pushData
        this.getDashChartsClient({PK: '#SMARTDASH', SK:'#SML#55994203-121c-4092-b8d6-36d90c65251a',GSP1PK1 :this.$router.currentRoute.value.query.data })
      } catch (error) {
        console.log(error);
      }
      setTimeout(() => {
        this.sub= false
        this.loading('close','updateRecord')
      }, 200);
    },
    async setStatus(pk, sk, action) {
      console.log(pk, sk);
      let status = ''
      let push =''
      if (action == 'active') {
        status ='1'
      }
      if (action == 'desactive') {
        status= '0'
      }
      if (action == 'archive') {
        status = '2'
      }
      console.log(action+'-'+status);
      push = await API.graphql({
        query: smd_setItemState,
        variables: { PK: pk, SK: sk, state: status},
      });
      console.log('After Query');
        console.log(push.data.smd_setItemState);
        console.log(action+": " + pk + " - " + sk);
        this.getDashChartsClient({PK: '#SMARTDASH', SK:'#SML#55994203-121c-4092-b8d6-36d90c65251a',GSP1PK1 :this.$router.currentRoute.value.query.data })
    },
    async setFavorite(PK, SK) {
      let pushData = ''
      try {
        pushData = await API.graphql({
          query: smd_addToFavorites,
          variables: { 
            PK: PK,
            SK: SK
          },
        });
        pushData = pushData.data.smd_addToFavorites
        console.log(pushData);
        Swal.fire(
          'Info',
          `${JSON.stringify(pushData)}`,
          'success'
        )
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: 'Something went wrong!' ,
          text: JSON.stringify(error.errors)
        })
      }
    },
    async setClone(PK, SK) {
      let pushData = ''
      try {
        pushData = await API.graphql({
          query: smd_cloneSmartRecord,
          variables: { 
            PK: PK,
            SK: SK
          },
        }); 
        pushData = pushData.data.smd_cloneSmartRecord
        console.log(pushData.smd_response);
        Swal.fire({
          icon: 'success',
          title: 'Successfully cloned' ,
          //text: pushData.smd_response.statusCode
        })
        this.getDashChartsClient({PK: '#SMARTDASH', SK:'#SML#55994203-121c-4092-b8d6-36d90c65251a',GSP1PK1 :this.$router.currentRoute.value.query.data })
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: 'Something went wrong!' ,
          text: JSON.stringify(error)
        })
      }
    },
    async userCreated(item) {
      console.log(item);
      let push =''
      try {        
        push = await API.graphql({
          query: smd_createUserFromEmail,
          variables: { 
            emailPK:item.PK,
            emailSK:item.SK
          },
        });
        console.log(push.data.smd_createUserFromEmail)
        Swal.fire(
          'Info',
          `${ JSON.stringify(push.data.smd_createUserFromEmail.smd_response, null, 4)}`,
          'success'
        )
      } catch (error) {
        console.log(error);
        Swal.fire( {
          icon: 'error',
          title: 'Something went wrong!' ,
          text: error
          }
        )
      }
    },
    inputHtml(name, data){
      try {
        document.getElementById('preview-wrap-'+name).innerHTML = data
      } catch (err) {
        console.log(err);
      }
    },
  },
  computed: {
    ...Vuex.mapState(["organizationID","userPermissions", "pageForm", "pageTable", "pageName", "item.shortEntity", "entity", "pageMeta", "pageModule", "permissions", "validationString", "user", 'recordView', "dataUser", 'dashData','recordLists','dataModule','organizationData','entities','modules',"customItem","menuModules"]),
  },
  watch: {
    /*record:{
      handler(val) {
        if (JSON.stringify(val.item.attributes) == val.attStr) {
          this.buttonsView('hide')
        }else{
          this.buttonsView('show')
        }
      },
      deep: true
    },*/
    url:function(value) {
      console.log(value);
    },
  },
}
</script>
<style lang="less">
  .hover(){ 
    -webkit-transition: all 0.3s ease 0s;
    -moz-transition: all 0.3s ease 0s;
    -ms-transition: all 0.3s ease 0s;
    -o-transition: all 0.3s ease 0s;
    transition: all 0.3s ease 0s;
  }
  .maker{
    padding: 30px;
    background: #fff;
    &.body{
      .constructor{
        resize: both;
        overflow: auto;
      }
      
    }
  }
  .customPanel{
    .nav-tabs{
      .nav-item{
        width:25%;
        text-align: center;
        .nav-link{
          background: #D9D9D9;
          border: none;
          color: #5A5A5A;
          border-radius: 0px;
          font-weight: 600;
          font-size: 14px;
          .hover();
          &.active{
            background: #fff;
          }
        }
      }
    }
    .tab-content{
      padding: 20px;
      .tab-pane{
        overflow: auto;
        height: 90vh;
        &.config{
          .list-languages{
            li{
              .hover();
              &.active{
                background: #D9D9D9;
                border: none;
              }
            }
          }
        }
      }
    }
    &.sticky{
      position: fixed;
      width: 31.1%;
      height: 100vh;
      top: 0;
      .hover;
    }
    .gallery{
      height: 100px;
      --height: 100px;
      --width: auto;
      display: flex;
      justify-content: center;
    } 
  }
  .customPanelOption{
    //border: 1px solid #ccc;
    width: 100%;
    padding: 10px 20px;
    font-weight: 600;
    label{
      width: 100%;
    }
    input{
      width: 100%;
    }
    .dropInput{
      float: left;
      width: 40px;
      display:block;
      height: 40px;
      padding: 10px;
      background: #D9D9D9;
      svg{
        width: 20px;
        height: 15px;
        path{
          stroke: #5A5A5A;
        }
      }
    }
    .drop{
      width: 100%;
      padding: 0 0 6px 0;
      overflow: hidden;
      color: #5A5A5A;
      border-bottom: 1px solid #ccc;
      display: block;
      &:hover{
        color: #5A5A5A;
      }
    }
  }
</style>x 